// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:22.828Z
// Property: Orchard Park (ID: 6767906449166333)
// Collections: 24 amenities, 14 floorplans (live), 31 photos, 82 POIs, 4 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166333",
  "property_external_id": "30941",
  "property_zillow_url": "https://www.zillow.com/apartments/edgewater-park-nj/orchard-park/5XqSYc/",
  "property_apartments_url": "https://www.apartments.com/orchard-park-edgewater-park-nj/p1bx8kr/",
  "property_google_business_url": "https://www.google.com/maps/place/Orchard+Park+Apartment+Homes/data=!4m2!3m1!1s0x0:0x3630bfe3d2580d93?sa=X&ved=2ahUKEwip6ZD_yLiSAxVshIkEHV4dCzEQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "6732006579",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "orchard-park",
  "property_name": "Orchard Park",
  "property_website_url": "https://www.liveorchardpark.com/",
  "property_domain": "https://www.liveorchardpark.com/",
  "property_address": "1020 Woodlane Road",
  "property_full_address": "1020 Woodlane Rd, Beverly, NJ 08010",
  "property_address_1": "1020 Woodlane Rd",
  "property_address_2": null,
  "property_address_city": "Beverly",
  "property_address_state": "NJ",
  "property_address_zip_full": "08010-3239",
  "property_address_zip": "08010",
  "property_address_country": "US",
  "property_address_county": "Burlington County",
  "property_neighborhood_address": "Burlington County",
  "property_address_latitude": "40.0548436",
  "property_address_longitude": "-74.894273",
  "property_email": "orchardpark@aionmanagement.com",
  "property_phone": "(609) 387-4992",
  "property_call_tracking_phone": "855-638-8985",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Orchard Park in charming Beverly, NJ, choose from one-bedroom, two-bedroom, or studio apartments designed for modern living. Enjoy amenities that elevate your lifestyle, including a shimmering swimming pool, playground, and convenient EV charging stations. Ready for a new home? Browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Orchard Park, your ideal apartment community nestled in the heart of Beverly, NJ. Our thoughtfully designed floor plans include spacious studio, one-bedroom, and two-bedroom layouts, each catering to your unique lifestyle. Experience the perfect blend of comfort and convenience as you explore our extensive array of property amenities.\n\nAt Orchard Park, we prioritize our residents' needs with a variety of thoughtful features. Enjoy a vibrant lifestyle with regular resident activities, an inviting swimming pool, and a sunny sundeck perfect for relaxation. Families will appreciate our playground, while pet owners will love our pet-friendly policies! Our community is designed for modern living, offering EV charging stations, a dedicated online resident portal, and flex rent payments for added flexibility.\n\nStay connected and secure with Amazon Hub lockers, on-site management, and 24-hour emergency maintenance. Our recently renovated apartments boast upgraded kitchens and bathrooms, modernized vinyl plank flooring, and cozy wall-to-wall carpeting. For added convenience, we provide on-site laundry facilities, available garages, and both on-site and off-street parking.\n\nWith the option for short-term leases and stunning courtyards to unwind, Orchard Park is the perfect place to call home. Don’t miss your chance to experience our AION Renovations firsthand! \n\nFind your new home today—browse our availability or schedule a tour of our beautiful community. Join us at Orchard Park, where you'll experience exceptional living!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-5522-716f-bf26-3427218e19ad.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of brick apartment buildings with a blue swimming pool and surrounding lounge chairs.",
    "public_id": "019d0268-5522-716f-bf26-3427218e19ad",
    "storage_key": "property/6767906449166333/019d0268-5522-716f-bf26-3427218e19ad.webp",
    "width": 2048,
    "height": 1536
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "281",
  "property_year_built": "1976",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.79715302491103",
  "property_admin_fee": "100",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, with a combined weight limit of 100 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $300 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://orchardpark.loftliving.com/login",
  "property_apply_now_url": "https://www.liveorchardpark.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-6483-75fb-a6fc-2eb4fbd2a8d5.webp",
  "property_primary_logo_media": {
    "alt_text": "Orchard Park Apartment Homes logo",
    "public_id": "019d026a-6483-75fb-a6fc-2eb4fbd2a8d5",
    "storage_key": "property/6767906449166333/019d026a-6483-75fb-a6fc-2eb4fbd2a8d5.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-5ca1-72bf-929b-e277e1522776.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026a-5ca1-72bf-929b-e277e1522776",
    "storage_key": "property/6767906449166333/019d026a-5ca1-72bf-929b-e277e1522776.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-70eb-742c-9898-bcadbd795695.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Orchard Park Apartment Homes logo",
    "public_id": "019d026a-70eb-742c-9898-bcadbd795695",
    "storage_key": "property/6767906449166333/019d026a-70eb-742c-9898-bcadbd795695.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-794a-774f-b51f-3a2b5b87d937.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Orchard Park Apartment Homes logo",
    "public_id": "019d026a-794a-774f-b51f-3a2b5b87d937",
    "storage_key": "property/6767906449166333/019d026a-794a-774f-b51f-3a2b5b87d937.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#1f2933",
  "property_color_4": null,
  "property_color_3": "#f18a00",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": " - 963",
  "property_sqft_min": "753",
  "property_sqft_max": "963",
  "property_price_range": "2089",
  "property_price_min": null,
  "property_price_max": "2089",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/LiveOrchardPark/",
  "property_instagram_url": "https://www.instagram.com/orchardparkapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGxQKahJMwYkRkw1Y0uO_MDY",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Scenic+View&find_loc=Beverly%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Orchard Park",
  "property_home_romance_title": "Embrace a Life of Connection in Your New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Orchard Park in Beverly, NJ, where modern living meets comfort. Choose from stylish studio, one, or two-bedroom floor plans featuring renovated kitchens and premium finishes. Enjoy community perks like a swimming pool, EV charging stations, and engaging resident activities. Your new home awaits in this pet-friendly oasis!",
  "property_home_floorplans_blurb": "Welcome to Orchard Park in Beverly, NJ, where modern living meets comfort. Choose from our thoughtfully designed one-bedroom, two-bedroom, and studio apartments that cater to your lifestyle. Each space boasts natural light and contemporary finishes. Browse our available apartment homes and find the perfect floor plan that suits you!",
  "property_home_gallery_blurb": "At Orchard Park in Beverly, NJ, your perfect home awaits with stylish one-bedroom, two-bedroom, and studio floor plans. Enjoy a vibrant community enriched with resident activities, pet-friendly spaces, and luxurious amenities like a refreshing swimming pool and serene sundeck. Picture yourself living here and embracing a lifestyle full of convenience and comfort!",
  "property_home_neighborhood_blurb": "Welcome to Orchard Park in Beverly, NJ, where vibrant living meets convenience. Enjoy beautifully designed floor plans—be it a cozy studio or spacious two-bedroom. Immerse yourself in a rich tapestry of local culture with attractions like the Adventure Aquarium, BB-62 Battleship New Jersey, and serene parks just minutes away.",
  "property_home_reviews_blurb": "At Orchard Park in Beverly, NJ, residents rave about the welcoming atmosphere and attentive staff. With quotes like “Christina makes calling the office a pleasurable experience,” and “I love my neighbors,” it's clear our community thrives on connection and comfort. Discover unbeatable living where kindness meets convenience!",
  "property_neighborhood_blurb": "At Orchard Park in Beverly, NJ, vibrant life thrives beyond your doorstep. Nestled near scenic parks and top-notch schools, you'll find enriching experiences like the Adventure Aquarium and the serene Rancocas Nature Center. Embrace community spirit with nearby attractions like the Freedom Mortgage Pavilion and bustling local shops. Explore your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Orchard Park in scenic Beverly, NJ, where modern living meets unparalleled comfort. Our diverse floor plans, including stylish studios and spacious two-bedrooms, invite you to experience upgraded interiors and a wealth of amenities—from a shimmering swimming pool to an engaging resident activities calendar. Embrace your new lifestyle today!",
  "property_applynow_blurb": "Welcome to Orchard Park in Beverly, NJ, where stylish floor plans meet modern amenities! Choose from our one-bedroom, two-bedroom, or cozy studio options. Enjoy perks like resident activities, EV charging stations, and a refreshing swimming pool. Ready to elevate your lifestyle? Lease online today and find your new home!",
  "property_contactus_blurb": "At Orchard Park in Beverly, NJ, our diverse floor plans—including stylish studios, spacious one-bedroom, and two-bedroom options—are designed to fit your lifestyle. With modern amenities and inviting spaces, you'll find the perfect home. Have questions? Contact our leasing team today for more details!",
  "property_faqs_blurb": "At Orchard Park in Beverly, NJ, we offer a variety of thoughtfully designed floor plans, including one-bedroom, two-bedroom, and studio options. Whether you seek coziness or space, we have the perfect home for you. Visit our FAQs page to get all the answers about our vibrant community!",
  "property_floorplans_blurb": "At Orchard Park in Beverly, NJ, elegant living awaits with our thoughtfully designed floor plans, including cozy studios, spacious one, and inviting two-bedroom apartments. Each layout blends comfort with style, creating the ideal sanctuary for you. Browse our available apartment homes and uncover your perfect fit today!",
  "property_gallery_blurb": "Nestled in charming Beverly, NJ, Orchard Park invites you to envision your ideal lifestyle. With modern floor plans—including inviting studios, one, and two-bedroom apartments—plus resort-style amenities like a sparkling swimming pool and a vibrant courtyard, it's time to picture yourself living here amidst comfort and convenience.",
  "property_interactivemap_blurb": "Welcome to Orchard Park in Beverly, NJ, where comfort meets convenience! Choose from our stylish one-bedroom, two-bedroom, or studio floor plans, and enjoy amenities like a sparkling swimming pool, resident activities, and pet-friendly spaces. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Orchard Park in charming Beverly, NJ, where your furry friends are cherished! Enjoy spacious apartment living with a pet-friendly atmosphere. With a maximum of two pets and a combined weight limit of 100 lbs, your companions can thrive by your side in this welcoming community.",
  "property_referafriend_blurb": "At Orchard Park in Beverly, NJ, our diverse floor plans—studio, one-bedroom, and two-bedroom apartments—cater to every lifestyle. Great friends make great neighbors, so invite your pals to join our vibrant community today! Embrace a life of comfort and connection at Orchard Park.",
  "property_residentaccess_blurb": "Welcome to Orchard Park in Beverly, NJ, where your perfect home awaits! Choose from our stylish studio, one-bedroom, or two-bedroom floor plans tailored for your lifestyle. Stay connected—access our resident portal to pay rent, schedule maintenance, and enjoy seamless living today! Your community is just a click away.",
  "property_reviews_blurb": "At Orchard Park in Beverly, NJ, our residents treasure the friendly atmosphere and supportive staff. As one resident notes, “Christina makes going to the rent office a pleasurable experience” while others appreciate the quiet community and attentive service. Experience the comfort of a home that feels just right. ",
  "property_created_at": "1757008570579",
  "property_scheduletour_blurb": "At Orchard Park in Beverly, NJ, choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that perfectly suit your lifestyle. Experience the charm of our community firsthand—schedule a tour today and hear what our residents love about calling Orchard Park home!",
  "property_thankyou_blurb": "Thank you for reaching out to Orchard Park in beautiful Beverly, NJ! With thoughtfully designed studio, one, and two-bedroom floor plans, your ideal home awaits. Keep an eye on your inbox—our friendly team will connect soon to help you start this exciting journey!",
  "property_virtualtours_blurb": "At Orchard Park in Beverly, NJ, our diverse floor plans—ranging from stylish studios to spacious two bedrooms—cater to every lifestyle. Immerse yourself in our vibrant community by taking a virtual tour today, and envision your perfect home nestled among nature's beauty. Experience life at Orchard Park like never before!",
  "property_copyright": "2025 All Rights Reserved. Orchard Park",
  "property_seo_title_home": "Orchard Park |  Apartments in Beverly, NJ",
  "property_seo_description_home": "Discover Orchard Park in Beverly, NJ! Enjoy stylish layouts, top amenities, and a community designed for you. Your new home is waiting!",
  "property_seo_title_floorplans": "Floor Plans | Beverly, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Orchard Park in Beverly, NJ. Choose from stylish studio, one, and two-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Beverly, NJ Apartments for Rent",
  "property_seo_description_amenities": "Relax at Orchard Park, Beverly, NJ! Enjoy resident events, a pool, pet-friendly areas, and modern interiors. Comfort and community await!",
  "property_seo_title_gallery": "Gallery | Apartments in Beverly, NJ",
  "property_seo_description_gallery": "Discover Orchard Park in Beverly, NJ! Explore our photo gallery and envision life in a charming, pet-friendly community with modern amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Orchard Park Apartments",
  "property_seo_description_virtualtours": "Step inside Orchard Park in Beverly, NJ! Experience inviting floor plans, from studios to two bedrooms. Take a virtual tour today and find your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Orchard Park Apartments",
  "property_seo_description_interactivemap": "Explore your ideal home at Orchard Park, Beverly, NJ! Use our map to discover one- and two-bedroom apartments with great amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beverly, NJ",
  "property_seo_description_neighborhood": "Experience the charm of Orchard Park in Beverly, NJ! Uncover local favorites and attractions just steps from your cozy one, two-bedroom, or studio home.",
  "property_seo_title_contact": "Contact Us | Orchard Park",
  "property_seo_description_contact": "Find your perfect home at Orchard Park in Beverly, NJ! Choose from stylish studio, one, or two-bedroom apartments. Our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Beverly, NJ",
  "property_seo_description_faqs": "Get answers to your top questions at Orchard Park in Beverly, NJ! Check out our FAQs for insights on amenities, floor plans, and community living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beverly, NJ",
  "property_seo_description_reviews": "Discover why Orchard Park in Beverly, NJ, feels like home through our residents' reviews. Experience comfort, convenience, and joy!",
  "property_seo_title_applynow": "Apply Now | Apartments in Beverly, NJ",
  "property_seo_description_applynow": "Find your perfect home at Orchard Park in Beverly, NJ! Enjoy modern amenities, spacious floor plans, and a vibrant community—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Orchard Park",
  "property_seo_description_residentaccess": "Unlock your Orchard Park resident portal in Beverly, NJ! Manage rent, request maintenance, and stay connected with your community—all in one convenient place.",
  "property_seo_title_referafriend": "Refer A Friend | Orchard Park",
  "property_seo_description_referafriend": "Refer a friend to Orchard Park in Beverly, NJ! Share the joy of great living—where friendships blossom and neighbors feel like family. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Orchard Park",
  "property_seo_description_scheduletour": "Discover life at Orchard Park in Beverly, NJ. Schedule a tour today to explore your future home amidst nature and modern comforts!",
  "property_seo_title_privacy": "Privacy Policy | Orchard Park",
  "property_seo_description_privacy": "Your privacy matters at Orchard Park. Dive into our policy to understand how we protect your information while you enjoy life in Beverly, NJ.",
  "property_seo_title_accessibility": "Website Accessibility | Orchard Park",
  "property_seo_description_accessibility": "At Orchard Park in Beverly, NJ, we prioritize digital accessibility for all. Experience our commitment to inclusivity and ease of access in every detail.",
  "property_seo_title_sitemap": "Sitemap | Orchard Park",
  "property_seo_description_sitemap": "Uncover the layout of Orchard Park in Beverly, NJ. Navigate our community features, amenities, and find your new home. Check out our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Orchard Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Orchard Park! Our team is excited to assist you in finding your perfect home in beautiful Beverly, NJ. Stay tuned for our reply!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293571390",
  "amenities": [
    {
      "id": "custom_10871326-41ef-41ee-92ed-71e5e2c02e52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8da89dca-6552-4154-80e4-94294ff1a7ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7862f9a6-1dc1-4539-8907-818576a5fc02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7bd9ebc-610e-43da-b897-deec8950b724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f740487-3bb0-4ca5-8543-6d93d252f264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_112db85f-4ddc-4e4e-95b7-ad763a2bbb13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f1b8678-29ca-4907-bb2c-e80e2d9a1f3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9b373f1-164a-430a-881a-1798fb4b6f69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6fbf57b5-73f4-40e7-b23a-e4ca98aac2f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3cd367d-71a3-4c0d-8c2c-9c2e2f5716e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Over the Range Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_959f9099-fde7-4e23-afcf-1d890352795c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_813db167-1a07-4417-b6ae-028fc4a1eaef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c57a718-a4b4-437a-a275-83e5084ffee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Apartments",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e1ecef3-b74b-47fd-9832-714d3e22de07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Kitchens and Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49b63928-37da-4232-8c91-be938d54ca7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood Flooring in Kitchen and Dining Room",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80ec403c-1cfa-4cd6-af31-9b41c3ddb23b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Wall to Wall Carpet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6314d6ed-6b26-435f-9e6b-da8ff5b781b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47eaf0b4-cd5c-4b90-9fb5-d65de1467945",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4037b477-cac2-43ca-a4de-9187a3ad0062",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14424e14-44e3-4957-b253-b57faf48eae4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_635600c7-f255-4e29-9956-77301144b316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4899f71-87cd-4574-b134-e71b35fcdcfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fdc63d2-3e22-480f-8ebd-1155f61bb0ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_389c5b47-9b3f-41fc-9459-e1cd9a87da1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "external_id": "false",
      "title": "Package Locker System",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b896e2a0-7e23-4177-970a-077a1484557b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-2980-724e-aa18-0dd7ff529e04.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dark wood cabinets, black appliances, and a dining table set for four.",
        "public_id": "019fd928-2980-724e-aa18-0dd7ff529e04",
        "storage_key": "property/6767906449166333/019fd928-2980-724e-aa18-0dd7ff529e04.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Interior of an apartment kitchen with dark wood cabinets and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/b5aafd083da9cd3786873867a4494665-1920w.jpg"
    },
    {
      "id": "custom_792b4ef4-5da1-40f3-a032-136092ac9590",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-2976-764f-a7ee-5b7c15796543.webp",
      "image_media": {
        "alt_text": "Kitchen area with a dining table for two and a compact kitchen setup.",
        "public_id": "019fd928-2976-764f-a7ee-5b7c15796543",
        "storage_key": "property/6767906449166333/019fd928-2976-764f-a7ee-5b7c15796543.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with light wood cabinets, vinyl flooring, a small dining table, and white appliances.",
      "link": "",
      "alt_text": "Apartment kitchen with light wood cabinets, white appliances, and a small dining table by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/8902a517efbbc81da34820235e50844f-d758ab53-1920w.jpg"
    },
    {
      "id": "custom_cb2058c1-acf6-49c6-8e84-e742e86959ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-3679-758d-b57f-9f5f6802ed59.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and TV.",
        "public_id": "019fd928-3679-758d-b57f-9f5f6802ed59",
        "storage_key": "property/6767906449166333/019fd928-3679-758d-b57f-9f5f6802ed59.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with neutral tones, a coffee table, wall TV, and decorative accents.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, coffee table, plants, and a large wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/fec1fccfbd508a6c8eddf31b7e45f056-1920w.webp"
    },
    {
      "id": "custom_2f58b842-5420-4617-8451-18b0239e8408",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-3ffc-71f8-95b3-622f7c5bc53b.webp",
      "image_media": {
        "alt_text": "Modern living room with a large TV, sofa, armchair, and coffee table.",
        "public_id": "019fd928-3ffc-71f8-95b3-622f7c5bc53b",
        "storage_key": "property/6767906449166333/019fd928-3ffc-71f8-95b3-622f7c5bc53b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment living area with neutral tones, comfortable seating, and contemporary artwork.",
      "link": "",
      "alt_text": "Living room in a modern apartment with beige sofas, a neutral rug, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/3901409daf4f7a584a6e95fbebd7fbcb-1920w.jpg"
    },
    {
      "id": "custom_e76872a0-9c47-486a-be32-eb200346cee9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-4a1d-725d-b5fc-a790780c106d.webp",
      "image_media": {
        "alt_text": "Bathroom with white tiled walls, dark wood vanity, white sink, and toilet.",
        "public_id": "019fd928-4a1d-725d-b5fc-a790780c106d",
        "storage_key": "property/6767906449166333/019fd928-4a1d-725d-b5fc-a790780c106d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Clean, modern apartment bathroom with a white sink and dark wood vanity, white tile walls, towels, and a decorative shower curtain.",
      "link": "",
      "alt_text": "Bright apartment bathroom with white tile walls, dark wood vanity, toilet, and patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/d6adbe83a08710814a1b6cd5190d7e4b-1920w.webp"
    },
    {
      "id": "custom_6fa23f62-36dc-457d-bca5-cd153760a41b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-4aed-7709-b18b-958a584268d1.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower curtain",
        "public_id": "019fd928-4aed-7709-b18b-958a584268d1",
        "storage_key": "property/6767906449166333/019fd928-4aed-7709-b18b-958a584268d1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bathroom with white tile, wood vanity, window, and blue towels.",
      "link": "",
      "alt_text": "Bathroom in an apartment with sink, toilet, tiled walls, window, and blue towel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/9a7462a105fab9169ad4e5cad8cbc400-1920w.webp"
    },
    {
      "id": "custom_31a498fe-636e-4bc2-b778-e440e2b61448",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-5438-7008-a996-6271c55b9bf7.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet.",
        "public_id": "019fd928-5438-7008-a996-6271c55b9bf7",
        "storage_key": "property/6767906449166333/019fd928-5438-7008-a996-6271c55b9bf7.webp",
        "width": 1920,
        "height": 2876
      },
      "title": "Apartment",
      "description": "In-home laundry area with a stacked washer and dryer inside a closet.",
      "link": "",
      "alt_text": "In-unit laundry closet with a stacked washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/81f10dc53d98eb7ccd2f022ae3175188-1920w.webp"
    },
    {
      "id": "custom_153e3cf8-2dad-4ece-acaa-4f07ca998bef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-5828-774a-bda4-11edafa8b8e8.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings, a swimming pool, and lush green surroundings under a partly cloudy sky.",
        "public_id": "019fd928-5828-774a-bda4-11edafa8b8e8",
        "storage_key": "property/6767906449166333/019fd928-5828-774a-bda4-11edafa8b8e8.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Bird’s-eye view of a multi-building apartment community featuring a central pool.",
      "link": "",
      "alt_text": "Aerial view of a brick apartment community with a central pool, parking, and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/30017858c38fb4cc54ebb5289a2367dd-a880b0d1-1920w.webp"
    },
    {
      "id": "custom_114c1210-d66d-4925-b073-0630f52c8f3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-628f-76bc-b635-5d0876878bca.webp",
      "image_media": {
        "alt_text": "Children's playground with slides and climbing structures.",
        "public_id": "019fd928-628f-76bc-b635-5d0876878bca",
        "storage_key": "property/6767906449166333/019fd928-628f-76bc-b635-5d0876878bca.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor community playground at the apartment complex featuring a green slide and climbing structures.",
      "link": "",
      "alt_text": "Outdoor playground with slides and climbing equipment on mulch, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/c26059f36711f59b7a48154b484e9d9e-1920w.webp"
    },
    {
      "id": "custom_27d2923c-be79-462a-b0e3-ba4f516760b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-6bcf-7469-992c-9c68bd6c7a52.webp",
      "image_media": {
        "alt_text": "Amazon Hub parcel lockers for package delivery",
        "public_id": "019fd928-6bcf-7469-992c-9c68bd6c7a52",
        "storage_key": "property/6767906449166333/019fd928-6bcf-7469-992c-9c68bd6c7a52.webp",
        "width": 1920,
        "height": 1439
      },
      "title": "Community",
      "description": "Secure parcel lockers at the apartment community for convenient package pickup and delivery.",
      "link": "",
      "alt_text": "Row of dark blue parcel lockers against a stone wall at an apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/f025e92f39b1bf4fb5bddfd08bf217c6-1920w.webp"
    },
    {
      "id": "custom_0cacb846-a633-4b9b-a0ad-4cf326caa559",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-6e26-779e-aade-f73840c43635.webp",
      "image_media": {
        "alt_text": "Brick apartment building exterior with manicured bushes and green lawn.",
        "public_id": "019fd928-6e26-779e-aade-f73840c43635",
        "storage_key": "property/6767906449166333/019fd928-6e26-779e-aade-f73840c43635.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Exterior view of a brick multifamily building with a small covered entry and neatly trimmed landscaping.",
      "link": "",
      "alt_text": "Brick apartment building exterior with a small covered entry and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/e441e115463636aac014036eeb31a777-1920w.webp"
    },
    {
      "id": "custom_6fa293f5-1b7a-41d5-a981-2e5399953178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab05-5d09-7656-a393-d933929a694a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and closet.",
        "public_id": "01a0ab05-5d09-7656-a393-d933929a694a",
        "storage_key": "property/6767906449166333/01a0ab05-5d09-7656-a393-d933929a694a.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed, a modern nightstand with a lamp, a dresser, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2117c039-a71e-46e2-a16f-7523089a781e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab05-3663-7638-b873-d939fc52ad57.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub.",
        "public_id": "01a0ab05-3663-7638-b873-d939fc52ad57",
        "storage_key": "property/6767906449166333/01a0ab05-3663-7638-b873-d939fc52ad57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this stylish bathroom featuring a sleek vanity with a black faucet, a clean white toilet, and a spacious bathtub with a modern showerhead.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_658886a3-cdac-4622-8e16-1769bf07dc29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab05-33f2-77bd-a4ba-986eeb8cd7c6.webp",
      "image_media": {
        "alt_text": "Row of stacked washers and dryers in a laundry room.",
        "public_id": "01a0ab05-33f2-77bd-a4ba-986eeb8cd7c6",
        "storage_key": "property/6767906449166333/01a0ab05-33f2-77bd-a4ba-986eeb8cd7c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "On-site laundry facilities available for residents, featuring multiple stacked washers and dryers for convenience.",
      "link": "",
      "alt_text": "Row of stacked washers and dryers in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5994e4de-5b6a-4bb8-b166-005c0b6c97eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab05-08e6-72fe-b33e-0968246a9f62.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, dresser, mirror, and closet.",
        "public_id": "01a0ab05-08e6-72fe-b33e-0968246a9f62",
        "storage_key": "property/6767906449166333/01a0ab05-08e6-72fe-b33e-0968246a9f62.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant dresser, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a queen bed, dresser, mirror, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f5557b0-28b6-400c-87f6-6bf40aba8763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab04-fc04-756a-8472-44081668f008.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and marble countertops, flowing into a living area with a sofa and TV.",
        "public_id": "01a0ab04-fc04-756a-8472-44081668f008",
        "storage_key": "property/6767906449166333/01a0ab04-fc04-756a-8472-44081668f008.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring white shaker cabinets, black appliances, and elegant marble countertops. The space seamlessly transitions into a comfortable living area, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and marble countertops, flowing into a living area with a sofa and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66bcc5c1-966b-403a-a557-da7d5d646a78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab04-fa23-7369-9183-784ab6ba0823.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a small dining table with two chairs.",
        "public_id": "01a0ab04-fa23-7369-9183-784ab6ba0823",
        "storage_key": "property/6767906449166333/01a0ab04-fa23-7369-9183-784ab6ba0823.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring sleek white cabinetry, a full suite of black appliances including a refrigerator, dishwasher, stove, and microwave, complemented by a chic dining set for two.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and a small dining table with two chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e46342b-a35d-49e7-b3a0-4a07b6d0b461",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab04-ec01-746d-b111-a119e999e876.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with stylish furniture and decor.",
        "public_id": "01a0ab04-ec01-746d-b111-a119e999e876",
        "storage_key": "property/6767906449166333/01a0ab04-ec01-746d-b111-a119e999e876.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area seamlessly connected to a modern kitchen, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen with stylish furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fec3ed71-b368-42c8-aaac-122e5b26b26f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab04-e361-75b6-a88b-540fba5c5483.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and black appliances, including a refrigerator, stove, and dishwasher. A small dining area with a glass table and chairs is visible.",
        "public_id": "01a0ab04-e361-75b6-a88b-540fba5c5483",
        "storage_key": "property/6767906449166333/01a0ab04-e361-75b6-a88b-540fba5c5483.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, black appliances, and ample counter space. Perfect for cooking and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets and black appliances, including a refrigerator, stove, and dishwasher. A small dining area with a glass table and chairs is visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b875ac25-19a3-482a-875d-da064e36ca06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-e7ed-749d-a3ab-cdc95b70ef12.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a queen-size bed, dresser, stacked washer and dryer, and ample closet space.",
        "public_id": "01a0ab03-e7ed-749d-a3ab-cdc95b70ef12",
        "storage_key": "property/6767906449166333/01a0ab03-e7ed-749d-a3ab-cdc95b70ef12.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting bedroom, complete with a plush queen-size bed, elegant dresser, and convenient in-unit washer and dryer. Plenty of closet space ensures effortless organization.",
      "link": "",
      "alt_text": "Spacious bedroom with a queen-size bed, dresser, stacked washer and dryer, and ample closet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3e47972-56e7-4641-a8bd-662fc4550ecd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-52eb-7148-a0fc-7d2461827e0a.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, armchair, coffee table, and sliding glass doors leading to a balcony.",
        "public_id": "01a0ab03-52eb-7148-a0fc-7d2461827e0a",
        "storage_key": "property/6767906449166333/01a0ab03-52eb-7148-a0fc-7d2461827e0a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa and a stylish armchair, perfect for relaxation. Enjoy the natural light and views from the sliding glass doors.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, armchair, coffee table, and sliding glass doors leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96705bbe-15de-4f81-bcd3-ce80cdec92c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-5eff-768b-9e11-8dc249580d82.webp",
      "image_media": {
        "alt_text": "Covered picnic area with grills and seating for outdoor dining.",
        "public_id": "01a0ab03-5eff-768b-9e11-8dc249580d82",
        "storage_key": "property/6767906449166333/01a0ab03-5eff-768b-9e11-8dc249580d82.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our community picnic area, featuring grills and covered seating for your convenience.",
      "link": "",
      "alt_text": "Covered picnic area with grills and seating for outdoor dining.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_543bff03-abe7-49f4-b0a7-16d1ccc6e812",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-3cbb-74dd-94f7-d55b960e0060.webp",
      "image_media": {
        "alt_text": "Bedroom with open closets and a bed with green and white bedding.",
        "public_id": "01a0ab03-3cbb-74dd-94f7-d55b960e0060",
        "storage_key": "property/6767906449166333/01a0ab03-3cbb-74dd-94f7-d55b960e0060.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with double doors, a comfortable bed with modern bedding, and large windows offering a view of trees.",
      "link": "",
      "alt_text": "Bedroom with open closets and a bed with green and white bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cdb57d6-8e07-4f2b-9f13-51c1b6e79a8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-6a08-7442-a4f9-63420a8e810c.webp",
      "image_media": {
        "alt_text": "Balcony with view of apartment buildings and green lawn.",
        "public_id": "01a0ab03-6a08-7442-a4f9-63420a8e810c",
        "storage_key": "property/6767906449166333/01a0ab03-6a08-7442-a4f9-63420a8e810c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony overlooking the community grounds.",
      "link": "",
      "alt_text": "Balcony with view of apartment buildings and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4bc7f82d-a695-422a-824f-4fa9d59d1865",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-5fb6-701e-a329-aaa7b2d8d5ff.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with green lawns and a sidewalk.",
        "public_id": "01a0ab03-5fb6-701e-a329-aaa7b2d8d5ff",
        "storage_key": "property/6767906449166333/01a0ab03-5fb6-701e-a329-aaa7b2d8d5ff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Charming brick apartment buildings with manicured lawns and a welcoming entrance.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with green lawns and a sidewalk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2daa0118-c329-4309-89a1-fa16f9045ad5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-3a33-71a8-9d7e-cc9b8236f309.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with white columns and a black entrance.",
        "public_id": "01a0ab03-3a33-71a8-9d7e-cc9b8236f309",
        "storage_key": "property/6767906449166333/01a0ab03-3a33-71a8-9d7e-cc9b8236f309.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its brick facade, white columns, and inviting black entrance.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with white columns and a black entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2db12211-3485-42cb-948f-73e34c705dd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-5509-75e4-8c9d-a6aa1add8957.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "01a0ab03-5509-75e4-8c9d-a6aa1add8957",
        "storage_key": "property/6767906449166333/01a0ab03-5509-75e4-8c9d-a6aa1add8957.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3baeb389-4a97-4e6a-9623-afe1bc4485b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-3a20-75ee-8031-4a6882ac623c.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and balcony access.",
        "public_id": "01a0ab03-3a20-75ee-8031-4a6882ac623c",
        "storage_key": "property/6767906449166333/01a0ab03-3a20-75ee-8031-4a6882ac623c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, stylish coffee table, and sliding doors that open to a private balcony.",
      "link": "",
      "alt_text": "Living room with sectional sofa, coffee table, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17b6cd2e-3167-4213-a3c2-cdb9803ce45e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab02-9d02-7568-9848-cfc5330476e0.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
        "public_id": "01a0ab02-9d02-7568-9848-cfc5330476e0",
        "storage_key": "property/6767906449166333/01a0ab02-9d02-7568-9848-cfc5330476e0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment for your furry friends to play and explore. Surrounded by our beautiful community and apartment buildings.",
      "link": "",
      "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41c21e34-bbd3-423e-afee-47e70e8d15df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-6f54-7423-aa3a-215769902013.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and flower beds.",
        "public_id": "019fd928-6f54-7423-aa3a-215769902013",
        "storage_key": "property/6767906449166333/019fd928-6f54-7423-aa3a-215769902013.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Brick apartment building with landscaped entrances and colorful flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/5e7be255/dms3rep/multi/opt/5767906449162442/6767906449166333/8fbdabac84efd334ed3a6ef533c37b76-1920w.png"
    },
    {
      "id": "custom_2923cff3-ab9f-4e2a-8e39-2fc1ecaa8ba0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab19-6f2f-7399-9484-90bcad52b944.webp",
      "image_media": {
        "alt_text": "Orchard Park building exterior with parking lot and vehicles.",
        "public_id": "01a0ab19-6f2f-7399-9484-90bcad52b944",
        "storage_key": "property/6767906449166333/01a0ab19-6f2f-7399-9484-90bcad52b944.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the Orchard Park building, showcasing its signage, brick facade, and surrounding parking area with various vehicles.",
      "link": "",
      "alt_text": "Orchard Park building exterior with parking lot and vehicles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f1f51672-1ec9-4b75-a7b2-91336d94a23c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Crazy Cow Steak & Pizza ",
      "poi_type": "Restaurants",
      "poi_address": "996 Woodlane Rd, Edgewater Park, NJ 08010",
      "poi_short_description": "Casual eatery serving up a diverse menu of hearty pizzas, cheesesteaks, and an array of Mexican-inspired favorites.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/JmeXNCsYL1k3kxF29",
      "poi_item_slug": "false",
      "poi_latitude": "40.0558567",
      "poi_longitude": "-74.8951858",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5522e067-7bb0-4712-9908-aee66a4b953a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "China Wok ",
      "poi_type": "Restaurants",
      "poi_address": "1008 Woodlane Rd, Beverly, NJ 08010",
      "poi_short_description": "Casual Chinese restaurant offering flavorful, affordable takeout and dine-in favorites like stir-fries, lo mein, and other classic dishes.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/PnojSUc9GwNdr96c8",
      "poi_item_slug": "false",
      "poi_latitude": "40.0556488",
      "poi_longitude": "-74.8950945",
      "poi_miles_from_property": "463 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20528501-e257-4c21-86a1-72f4023825a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Friend Coffee Shop ",
      "poi_type": "Restaurants",
      "poi_address": "4385 US-130, Edgewater Park, NJ 08010",
      "poi_short_description": "Cafe serving Turkish-inspired coffee and eats with a friendly atmosphere and flavorful dishes.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/G81MmXAKQx7dJ2SM9",
      "poi_item_slug": "false",
      "poi_latitude": "40.0547649",
      "poi_longitude": "-74.8918121",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60a0886f-5755-4258-9c30-f1a5f9eae2b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "4380 US-130, Willingboro, NJ 08046",
      "poi_short_description": "Global coffeehouse chain known for its handcrafted espresso drinks, brewed coffee, teas, pastries, and more.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/qadx7qivdN8PUw3NA",
      "poi_item_slug": "false",
      "poi_latitude": "40.054979",
      "poi_longitude": "-74.889344",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2206a62-b72d-4a88-9ee3-d76559afd8ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Golden Dawn Diner",
      "poi_type": "Restaurants",
      "poi_address": "4387 US-130, Burlington, NJ 08016",
      "poi_short_description": "Classic American diner serving hearty comfort food, breakfast all day, and friendly service in a casual, family-friendly setting.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/m3BjSKpAbjVzHGLU7",
      "poi_item_slug": "false",
      "poi_latitude": "40.05514",
      "poi_longitude": "-74.8911487",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3f04405b-fc48-4f32-8f77-3f3f56681a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Bagelati",
      "poi_type": "Restaurants",
      "poi_address": "1096 US-130, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Bagel shop offering sandwiches, plus breakfast items, ice cream, coffee, and smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-f95f-763a-8e4d-1aabbbd0fff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-f95f-763a-8e4d-1aabbbd0fff8",
        "storage_key": "property/6767906449166333/019fd926-f95f-763a-8e4d-1aabbbd0fff8.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://bagelati.com/",
      "poi_directions_map_url": "https://maps.app.goo.gl/vQfUsgyarXLAAfbs6",
      "poi_item_slug": "bagelati",
      "poi_latitude": "39.9965715",
      "poi_longitude": "-74.9915159",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 856-314-8608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23AX8_m1xokRRT12ppZmvmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e896912-29fa-467a-a6e8-141334d72655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Cinnaminson Diner",
      "poi_type": "Restaurants",
      "poi_address": "1202 Rt. 130 North, 1202 Burlington Pike, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Family-run diner offering a large menu for breakfast, lunch, and dinner, plus ice cream, cakes and pizza.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-b59c-76cf-b09f-92d4241cab33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-b59c-76cf-b09f-92d4241cab33",
        "storage_key": "property/6767906449166333/019fd926-b59c-76cf-b09f-92d4241cab33.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.cinnaminsondiners.net/",
      "poi_directions_map_url": "https://maps.app.goo.gl/DEw8fQeMScA8MwfT6",
      "poi_item_slug": "cinnaminson-diner",
      "poi_latitude": "39.9984161",
      "poi_longitude": "-74.988824",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-314-8932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2xPAuj-1xokRhaK9dPHFvg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_394f56f7-60a7-4eb8-bf4e-7b8ccbf4dd54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Tokyo Bleu",
      "poi_type": "Restaurants",
      "poi_address": "602 US-130, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "South Jersey Japanese & sushi restaurant offers traditional array of hot meals, sashimi & rolls.",
      "poi_long_description": "South Jersey Japanese & sushi restaurant offers traditional array of hot meals, sashimi & rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-c6c5-70b1-9154-122c2538130a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-c6c5-70b1-9154-122c2538130a",
        "storage_key": "property/6767906449166333/019fd926-c6c5-70b1-9154-122c2538130a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tokyobleunj.com/",
      "poi_directions_map_url": "https://maps.app.goo.gl/rhFgUE91SY99U7DCA",
      "poi_item_slug": "tokyo-bleu",
      "poi_latitude": "39.99438869999999",
      "poi_longitude": "-74.9971563",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 856-829-8889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnay41G21xokRw-UrwkEgKts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_985242d5-55ce-4de6-8990-5701e3f67171",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "The Jug Handle Inn",
      "poi_type": "Restaurants",
      "poi_address": "1018 Forklanding Rd, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Known for its wings, this joint also offers other bar food, plus a patio for playing horseshoes.",
      "poi_long_description": "Known for its wings, this joint also offers other bar food, plus a patio for playing horseshoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-b626-729b-8393-c953209dd168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-b626-729b-8393-c953209dd168",
        "storage_key": "property/6767906449166333/019fd926-b626-729b-8393-c953209dd168.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://www.thejughandleinn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3522233914063414058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-jug-handle-inn",
      "poi_latitude": "39.9773485",
      "poi_longitude": "-75.0133098",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-665-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cc1-713d-a9af-c78019322c1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cc1-713d-a9af-c78019322c1e",
        "storage_key": "property/6767906449166333/019d0269-0cc1-713d-a9af-c78019322c1e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81XIsobKxokRKmOVTxV94TA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_922504ea-3b94-472a-82f8-49c483704e71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Whistlers Inn",
      "poi_type": "Restaurants",
      "poi_address": "901 US-130, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Wings & ribs from an on-site smokehouse, served in an English publike interior & on an outdoor deck.",
      "poi_long_description": "Wings & ribs from an on-site smokehouse, served in an English publike interior & on an outdoor deck.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-c80d-7468-b0db-9d404c12727d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-c80d-7468-b0db-9d404c12727d",
        "storage_key": "property/6767906449166333/019fd926-c80d-7468-b0db-9d404c12727d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.whistlersinnnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1147538468142480639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whistlers-inn",
      "poi_latitude": "39.99639",
      "poi_longitude": "-74.99472639999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-786-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RfdImu1xokR_3y6Jyjg7A8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52130b0c-67c8-4499-9475-05cb4225fad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Bella Rosa (previously Zio's Tuscan Grille)",
      "poi_type": "Restaurants",
      "poi_address": "202 US-130, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Laid-back Italian option with booths whipping up brick-oven pies, panini & traditional entrees.",
      "poi_long_description": "Laid-back Italian option with booths whipping up brick-oven pies, panini & traditional entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-d593-77ef-82ff-3855bcce3e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-d593-77ef-82ff-3855bcce3e95",
        "storage_key": "property/6767906449166333/019fd926-d593-77ef-82ff-3855bcce3e95.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.bellarosaitalianrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18213476879410495491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bella-rosa-previously-zios-tuscan-grille",
      "poi_latitude": "39.9867129",
      "poi_longitude": "-75.00967829999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 856-303-0013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_2q8Hi1xokRA4ANArlEw_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3815672-83a6-428f-9d55-6a7bb20232cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Double Nickel Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1585 NJ-73, Pennsauken, NJ 08110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-dc26-77f3-936c-24b981953b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-dc26-77f3-936c-24b981953b68",
        "storage_key": "property/6767906449166333/019fd926-dc26-77f3-936c-24b981953b68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dnbcbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2910581475824698196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "double-nickel-brewing-company",
      "poi_latitude": "39.9847057",
      "poi_longitude": "-75.0205704",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-356-2499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdB_toa1xokRVANdbG52ZCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58b395b5-c967-42f0-ae74-18edee040236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Curran's Irish Inn",
      "poi_type": "Restaurants",
      "poi_address": "5 W Broad St, Palmyra, NJ 08065, USA",
      "poi_short_description": "Local watering hole with regular special events like trivia nights & band performances.",
      "poi_long_description": "Local watering hole with regular special events like trivia nights & band performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-d20d-763b-bc07-5dd20768d38f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-d20d-763b-bc07-5dd20768d38f",
        "storage_key": "property/6767906449166333/019fd926-d20d-763b-bc07-5dd20768d38f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://curransirishinnbensalem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=700609517570345122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "currans-irish-inn",
      "poi_latitude": "40.0040096",
      "poi_longitude": "-75.0222264",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-314-8241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cc1-713d-a9af-c78019322c1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cc1-713d-a9af-c78019322c1e",
        "storage_key": "property/6767906449166333/019d0269-0cc1-713d-a9af-c78019322c1e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJra-JsKO1xokRosgJ7aQQuQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b74ce4b2-c5dd-4e11-8a3e-4519b4045a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Manny's Sicilia Pizza",
      "poi_type": "Restaurants",
      "poi_address": "17 W Broad St, Palmyra, NJ 08065, USA",
      "poi_short_description": "Local pick for tomato pies, hoagies & a long list of Italian-American classics in an informal nook.",
      "poi_long_description": "Local pick for tomato pies, hoagies & a long list of Italian-American classics in an informal nook.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-ddae-72ee-85cf-cbf69d7dd921.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-ddae-72ee-85cf-cbf69d7dd921",
        "storage_key": "property/6767906449166333/019fd926-ddae-72ee-85cf-cbf69d7dd921.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bcater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7751830365445382584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mannys-sicilia-pizza",
      "poi_latitude": "40.00388890000001",
      "poi_longitude": "-75.0225",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-829-6363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyzYqrKO1xokRuGF1e6UIlGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5be44bbe-4eea-45fe-9011-ea265ce74d20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Great Taste Chinese Food",
      "poi_type": "Restaurants",
      "poi_address": "111 E Broad St, Palmyra, NJ 08065, USA",
      "poi_short_description": "Casual take-out-heavy Chinese restaurant featuring fried dumplings, General Tso chicken and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-f46c-70eb-ae7d-052dec36147c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-f46c-70eb-ae7d-052dec36147c",
        "storage_key": "property/6767906449166333/019fd926-f46c-70eb-ae7d-052dec36147c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16857747215334436983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-taste-chinese-food",
      "poi_latitude": "40.0051692",
      "poi_longitude": "-75.020567",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-829-0336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz01Y-6O1xokRd_BWs8a_8uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6facb797-7987-43af-817d-8b2bffa8644e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Hibachi Grill & Supreme Buffet",
      "poi_type": "Restaurants",
      "poi_address": "1103 Us Hwy No 130 S, Cinnaminson, NJ 08077, USA",
      "poi_short_description": "Asian buffet options include a hibachi chef who grills meats & veggies to order plus a sushi bar.",
      "poi_long_description": "Asian buffet options include a hibachi chef who grills meats & veggies to order plus a sushi bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-ef77-716d-9e77-2c199339cd29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-ef77-716d-9e77-2c199339cd29",
        "storage_key": "property/6767906449166333/019fd926-ef77-716d-9e77-2c199339cd29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15661079101320135831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hibachi-grill--supreme-buffet",
      "poi_latitude": "39.999056",
      "poi_longitude": "-74.990983",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-829-5988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0cac-7332-b270-eb973bf3c102",
        "storage_key": "property/6767906449166333/019d0269-0cac-7332-b270-eb973bf3c102.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0cg1fhW1xokRlwR7eXdUV9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5881b67-d85a-4099-a17c-d7b1b74be8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Meet & Greens",
      "poi_type": "Shopping",
      "poi_address": "1000 Woodlane Rd, Beverly, NJ 08010",
      "poi_short_description": "Specialty market offering quality fresh meats, produce, and a variety of grocery essentials.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/6UTScUybCRHViJKr5",
      "poi_item_slug": "false",
      "poi_latitude": "40.0557271",
      "poi_longitude": "-74.8950945",
      "poi_miles_from_property": "486 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_875c4499-c1ad-4f0c-b178-6f6aa7c54eb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "K&K Nails ",
      "poi_type": "Shopping",
      "poi_address": "998 Woodlane Rd Edgewater Park, Beverly, NJ 08010",
      "poi_short_description": "A clean, fresh, and well-ventilated salon where you can truly relax.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/nvvrtvQbcn9XQBWE9",
      "poi_item_slug": "false",
      "poi_latitude": "40.0557999",
      "poi_longitude": "-74.8952482",
      "poi_miles_from_property": "489 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a800640-2c60-466b-a960-798f20a57c94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Acme",
      "poi_type": "Shopping",
      "poi_address": "23 Levitt Pkwy, Willingboro, NJ 08046",
      "poi_short_description": "Neighborhood grocery store offering fresh produce, quality meats, pantry staples, and everyday essentials.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.app.goo.gl/9dNkm9WtZf8GuNZt6",
      "poi_item_slug": "false",
      "poi_latitude": "40.05218",
      "poi_longitude": "-74.89466999999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_acedce7d-bdd4-498d-a637-9a4616c9c5b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "ShopRite of Burlington",
      "poi_type": "Shopping",
      "poi_address": "1817 Mt Holly Rd, Burlington, NJ 08016, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-f160-77aa-930f-17a50a94567c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd926-f160-77aa-930f-17a50a94567c",
        "storage_key": "property/6767906449166333/019fd926-f160-77aa-930f-17a50a94567c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=579",
      "poi_directions_map_url": "https://maps.google.com/?cid=11343562275118566003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-burlington",
      "poi_latitude": "40.0534504",
      "poi_longitude": "-74.8400219",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 609-387-1602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d0e-769c-9bd1-83c599a86d7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d0e-769c-9bd1-83c599a86d7c",
        "storage_key": "property/6767906449166333/019d0269-0d0e-769c-9bd1-83c599a86d7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTaG1E8NOwYkRc8r218ltbJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_829485c9-30e4-4b01-ace5-5bf8932983f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "2106 Mt Holly Rd, Burlington, NJ 08016, USA",
      "poi_short_description": "Low-price supermarket, department store, electronics shop, home goods store, furniture store and toy store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0c3e-703f-a5a5-7eade896575d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-0c3e-703f-a5a5-7eade896575d",
        "storage_key": "property/6767906449166333/019fd927-0c3e-703f-a5a5-7eade896575d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2040-burlington-nj/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2716399336212135992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "40.0477867",
      "poi_longitude": "-74.8424911",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 609-386-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-27492be62bc8",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKYP9htBOwYkROAAI382WsiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46d1a86e-be72-48d3-b3dc-38aec916200f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "2703 County Rd 541, Burlington Township, NJ 08016, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0875-778d-929e-f1612141ea24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-0875-778d-929e-f1612141ea24",
        "storage_key": "property/6767906449166333/019fd927-0875-778d-929e-f1612141ea24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/burlington/1158",
      "poi_directions_map_url": "https://maps.google.com/?cid=14553883070957213031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.0360565",
      "poi_longitude": "-74.8225479",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 609-239-9885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-27492be62bc8",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIVfD0SpPwYkRZ9X5EovH-ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c1b9e0ec-b036-4ca9-9008-79ff0eeedd24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "4296 US-130, Willingboro, NJ 08046, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0cd3-770d-bd32-c61a79bb4c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-0cd3-770d-bd32-c61a79bb4c32",
        "storage_key": "property/6767906449166333/019fd927-0cd3-770d-bd32-c61a79bb4c32.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4296+route+130-willingboro-nj-08046/id=5987",
      "poi_directions_map_url": "https://maps.google.com/?cid=12717403342269227439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.045957",
      "poi_longitude": "-74.90335019999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-871-9017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkw8AH3ZMwYkRr6FSyfVKfbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9dc06e47-0bde-4600-af7e-2242e374b3f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Sunny Food Mart",
      "poi_type": "Shopping",
      "poi_address": "700 Warren St, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18050598333349313339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunny-food-mart",
      "poi_latitude": "40.0632591",
      "poi_longitude": "-74.92381189999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-387-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-217275a275de",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJVSGbLIpMwYkROzuLSoybgPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd5c0eaa-b081-4f77-9916-7549f6644d4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Win Convenience",
      "poi_type": "Shopping",
      "poi_address": "413 Delanco Rd, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0c00-71ea-86e3-132e4704a3f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-0c00-71ea-86e3-132e4704a3f7",
        "storage_key": "property/6767906449166333/019fd927-0c00-71ea-86e3-132e4704a3f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5606195154346648048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "win-convenience",
      "poi_latitude": "40.0454352",
      "poi_longitude": "-74.9194775",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 609-531-2808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-217275a275de",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJOwfGT2dLwYkR8CFZPMo0zU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5639cff-82a2-49fd-a552-57aec7e15777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Krauszer’s Food Mart",
      "poi_type": "Shopping",
      "poi_address": "225 S Pavilion Ave, Riverside, NJ 08075, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-1fb6-7693-86f8-2be4ff8f7793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-1fb6-7693-86f8-2be4ff8f7793",
        "storage_key": "property/6767906449166333/019fd927-1fb6-7693-86f8-2be4ff8f7793.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10439758772992476366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krauszers-food-mart",
      "poi_latitude": "40.0361489",
      "poi_longitude": "-74.9595322",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-824-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-217275a275de",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJuSx_EUlLwYkRzgT8tEp54ZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df4da8de-7a18-4fe5-91ab-224be6728091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Country Farms",
      "poi_type": "Shopping",
      "poi_address": "1307 Woodlane Rd, Mt Holly, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7778776198290311651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-farms",
      "poi_latitude": "40.0051563",
      "poi_longitude": "-74.7628139",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-217275a275de",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-217275a275de.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJMyjpk3hHwYkR44lbFr3D82s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_262357b1-c942-4fb7-b677-236f2f53356d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Edgewater Building Supply",
      "poi_type": "Shopping",
      "poi_address": "704 Woodlane Rd, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-2184-70fa-98e7-5b243dd82429.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-2184-70fa-98e7-5b243dd82429",
        "storage_key": "property/6767906449166333/019fd927-2184-70fa-98e7-5b243dd82429.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/edgewaterbuildingsupply/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3272494432335249611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgewater-building-supply",
      "poi_latitude": "40.0651347",
      "poi_longitude": "-74.8997306",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 609-387-0136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1284-725c-a05d-27492be62bc8",
        "storage_key": "property/6767906449166333/019d0269-1284-725c-a05d-27492be62bc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPWmkgO9NwYkRy0DJCFk8ai0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e0e9de4c-b306-455a-ae92-bcd6a0d83ddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Beverly City School",
      "poi_type": "Education",
      "poi_address": "601 Bentley Ave, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-1838-7268-af2c-c87e336e1865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-1838-7268-af2c-c87e336e1865",
        "storage_key": "property/6767906449166333/019fd927-1838-7268-af2c-c87e336e1865.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.beverlycityschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6637849561463237924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beverly-city-school",
      "poi_latitude": "40.06047969999999",
      "poi_longitude": "-74.9229149",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 609-387-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf1SpsIlMwYkRJK1_3wFhHlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00844440-d7b3-4264-9938-8880fa0009d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Magowan Elementary School",
      "poi_type": "Education",
      "poi_address": "405 Cherrix Ave, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.edgewaterparksd.org/mildred-magowan-elementary-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=7973767868263896406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magowan-elementary-school",
      "poi_latitude": "40.0578822",
      "poi_longitude": "-74.9087359",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-877-1430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYYkgvm9MwYkRVhVLHaGDqG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2074c000-8e2f-4e42-925e-b514dda4d79a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Samuel M Ridgway School",
      "poi_type": "Education",
      "poi_address": "300 Delanco Rd, Edgewater Park, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-27af-71c4-8604-ee0a370fceef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-27af-71c4-8604-ee0a370fceef",
        "storage_key": "property/6767906449166333/019fd927-27af-71c4-8604-ee0a370fceef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edgewaterparksd.org/samuel-m-ridgway-middle-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=15068564855143342727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "samuel-m-ridgway-school",
      "poi_latitude": "40.0464133",
      "poi_longitude": "-74.91475729999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-871-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRR45qYBLwYkRhyLBKeZLHtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_781276fc-dcf0-424f-ad64-e22277c036ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Charles Street School",
      "poi_type": "Education",
      "poi_address": "100 W Charles St, Palmyra, NJ 08065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.palmyraschools.com/o/css",
      "poi_directions_map_url": "https://maps.google.com/?cid=3565733430747866009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-street-school",
      "poi_latitude": "39.9976131",
      "poi_longitude": "-75.0219764",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-829-3601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ658wbpm1xokRmSN2x6kHfDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86179960-9e4d-4c2d-923c-a4b310fb0b29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Palmyra High School",
      "poi_type": "Education",
      "poi_address": "311 W 5th St, Palmyra, NJ 08065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-2a9c-72d0-ad40-1025c604025a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-2a9c-72d0-ad40-1025c604025a",
        "storage_key": "property/6767906449166333/019fd927-2a9c-72d0-ad40-1025c604025a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.palmyraschools.com/o/phs",
      "poi_directions_map_url": "https://maps.google.com/?cid=126195428086851355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmyra-high-school",
      "poi_latitude": "40.0028273",
      "poi_longitude": "-75.02761389999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 856-786-8050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwg5Zb21xokRGydlvxJWwAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f920d1d1-ca1e-4b55-9d93-61b6bccb16b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "BCIT Westampton",
      "poi_type": "Education",
      "poi_address": "695 Woodlane Rd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bcit.cc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4369053670050898702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bcit-westampton",
      "poi_latitude": "40.0190704",
      "poi_longitude": "-74.82296649999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 609-267-4226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEQrirR1MwYkRDiMAKCr_oTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bbb1e7c6-c77e-4fe6-a38a-0391ef587f51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Rowan College at Burlington County",
      "poi_type": "Education",
      "poi_address": "900 College Cir, Mt Laurel Township, NJ 08054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-2a5d-76cc-aa3f-5af0b948e9cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-2a5d-76cc-aa3f-5af0b948e9cb",
        "storage_key": "property/6767906449166333/019fd927-2a5d-76cc-aa3f-5af0b948e9cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rcbc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12493884622714298702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-college-at-burlington-county",
      "poi_latitude": "39.9710762",
      "poi_longitude": "-74.8933405",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 856-222-9311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2Y7nwA1KwYkRTuGZcd4xY60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3ba869ee-aa8c-4a7f-b531-694eace549b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Holy Cross Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "5035 US-130, Delran, NJ 08075, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-2aca-754d-bb96-2ec95f9d4b14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-2aca-754d-bb96-2ec95f9d4b14",
        "storage_key": "property/6767906449166333/019fd927-2aca-754d-bb96-2ec95f9d4b14.webp",
        "width": 685,
        "height": 647
      },
      "poi_business_url": "http://hcprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2633557283504127226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-preparatory-academy",
      "poi_latitude": "40.0199488",
      "poi_longitude": "-74.9527517",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-461-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPRSFOiVLwYkR-vznamVGjCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3dfd0fd9-0d48-430a-863c-eed31d42f7e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "The Learning Experience - Edgewater Park",
      "poi_type": "Education",
      "poi_address": "4173 US-130, Edgewater Park, NJ 08010, USA",
      "poi_short_description": "Educational day care center for kids as young as 6 weeks, offering an all-inclusive curriculum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-316b-70de-b058-817227dab82d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-316b-70de-b058-817227dab82d",
        "storage_key": "property/6767906449166333/019fd927-316b-70de-b058-817227dab82d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://thelearningexperience.com/center/edgewater-park,-nj",
      "poi_directions_map_url": "https://maps.google.com/?cid=16524037462575850646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-learning-experience---edgewater-park",
      "poi_latitude": "40.0368198",
      "poi_longitude": "-74.9201008",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-733-4179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoyb0tnBLwYkRlqQULIYsUeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ae5d2ab-d674-43c4-b327-7413dd00fb75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Kiddie Kastle Learning Center",
      "poi_type": "Education",
      "poi_address": "4202 US-130, Willingboro, NJ 08046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kiddiekastlelearningcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1974328802956668104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-kastle-learning-center",
      "poi_latitude": "40.0370556",
      "poi_longitude": "-74.91655399999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 609-835-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR7YKZoNLwYkRyOwN-pU5Zhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6b4b35d5-d405-4ae8-ab22-f5c90c6a98ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Adventure Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_long_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-3dc1-74ad-866f-95bbabb88fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-3dc1-74ad-866f-95bbabb88fc7",
        "storage_key": "property/6767906449166333/019fd927-3dc1-74ad-866f-95bbabb88fc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventureaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298813021411118508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-aquarium",
      "poi_latitude": "39.9460868",
      "poi_longitude": "-75.1311712",
      "poi_miles_from_property": "18.4 mi",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 844-474-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBU1gv_LIxokRrI1AakMG5x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe990794-c57b-4b05-8c52-5f82d05a457c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "BB-62 Battleship New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "100 Clinton St, Camden, NJ 08103, USA",
      "poi_short_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_long_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-35fe-7558-a814-7943a2ab5b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-35fe-7558-a814-7943a2ab5b4c",
        "storage_key": "property/6767906449166333/019fd927-35fe-7558-a814-7943a2ab5b4c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.battleshipnewjersey.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11001799642450627255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-62-battleship-new-jersey",
      "poi_latitude": "39.9394484",
      "poi_longitude": "-75.1330734",
      "poi_miles_from_property": "18.8 mi",
      "poi_walking_minutes": "6 hours 54 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 856-966-1652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-13f9-7018-95da-d380bbb35578.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-13f9-7018-95da-d380bbb35578",
        "storage_key": "property/6767906449166333/019d0269-13f9-7018-95da-d380bbb35578.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxvwROrIxokRtwpKGnw-rpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff5624e6-0c02-43ab-a505-515445699a7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Freedom Mortgage Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "1 Harbour Blvd, Camden, NJ 08103, USA",
      "poi_short_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_long_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-6d41-70ba-bfba-e0ca0e925d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-6d41-70ba-bfba-e0ca0e925d02",
        "storage_key": "property/6767906449166333/019fd927-6d41-70ba-bfba-e0ca0e925d02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freedommortgagepavilion.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5807470010840392946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-mortgage-pavilion",
      "poi_latitude": "39.9404754",
      "poi_longitude": "-75.13001249999999",
      "poi_miles_from_property": "18.5 mi",
      "poi_walking_minutes": "6 hours 48 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 856-365-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6o4sfPIxokR8iTgnzRHmFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e5c5662-3812-477c-9468-3a23dc881b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Camden Children's Garden",
      "poi_type": "Entertainment",
      "poi_address": "3 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_long_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-46a9-715c-b26a-75718dc62b84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-46a9-715c-b26a-75718dc62b84",
        "storage_key": "property/6767906449166333/019fd927-46a9-715c-b26a-75718dc62b84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2467232925781527763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-childrens-garden",
      "poi_latitude": "39.9441667",
      "poi_longitude": "-75.1305556",
      "poi_miles_from_property": "18.4 mi",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 856-365-8733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJebu8Oe3IxokR0wxbJ0ZfPSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07f861e6-c415-43d5-be79-b27573f20210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Walt Whitman House",
      "poi_type": "Entertainment",
      "poi_address": "Hours subject to change Visits by guided tour only Call for tour schedule 328 Mickle/Martin Luther King Jr. Blvd, Camden, NJ 08103, USA",
      "poi_short_description": "Famed poet Walt Whitman’s preserved former home where he died, open to the public for tours.",
      "poi_long_description": "Famed poet Walt Whitman’s preserved former home where he died, open to the public for tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-4e99-72f8-b2a6-b1bf3368ab1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-4e99-72f8-b2a6-b1bf3368ab1f",
        "storage_key": "property/6767906449166333/019fd927-4e99-72f8-b2a6-b1bf3368ab1f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://thewaltwhitmanassociation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3159837618105713207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walt-whitman-house",
      "poi_latitude": "39.9423891",
      "poi_longitude": "-75.1235078",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 856-964-5383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0HTQe7IxokRN4Ibd5L_2Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a5ba449-9b53-472e-a5b2-b59604f1dca6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Regal Moorestown Mall",
      "poi_type": "Entertainment",
      "poi_address": "400 NJ-38, Moorestown, NJ 08057, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-52ec-75c5-a6d0-166b85bdaf4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-52ec-75c5-a6d0-166b85bdaf4f",
        "storage_key": "property/6767906449166333/019fd927-52ec-75c5-a6d0-166b85bdaf4f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-moorestown-mall-rpx-1917?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=678566796213433686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-moorestown-mall",
      "poi_latitude": "39.9428205",
      "poi_longitude": "-74.963415",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1ae9-709f-a1bc-0614193bc832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1ae9-709f-a1bc-0614193bc832",
        "storage_key": "property/6767906449166333/019d0269-1ae9-709f-a1bc-0614193bc832.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0W5jC01wYkRVjWt7OfAagk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b2299cd-cd85-42c6-9f96-8748a3ab7826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "AMC Neshaminy 24",
      "poi_type": "Entertainment",
      "poi_address": "660 Neshaminy Mall, Bensalem, PA 19020, USA",
      "poi_short_description": "Chain multiplex featuring IMAX and Dolby sound systems, plus spacious seating and reclining chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-5ac7-7151-a9ec-2c497b722ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-5ac7-7151-a9ec-2c497b722ddd",
        "storage_key": "property/6767906449166333/019fd927-5ac7-7151-a9ec-2c497b722ddd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-neshaminy-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053056166840425714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-neshaminy-24",
      "poi_latitude": "40.140225",
      "poi_longitude": "-74.954105",
      "poi_miles_from_property": "23.5 mi",
      "poi_walking_minutes": "8 hours 44 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 215-396-8050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1ae9-709f-a1bc-0614193bc832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1ae9-709f-a1bc-0614193bc832",
        "storage_key": "property/6767906449166333/019d0269-1ae9-709f-a1bc-0614193bc832.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRjHmK5SwYkR8txaUrkORac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20f45f75-5981-45ab-95f7-dbf7b7423109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington Riverfront Promenade",
      "poi_type": "Entertainment",
      "poi_address": "Burlington Riverfront Promenade, Burlington, NJ 08016, USA",
      "poi_short_description": "Park with a basketball court and picnic tables, plus areas for walking and watching boats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-691a-770f-ac47-357106939128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-691a-770f-ac47-357106939128",
        "storage_key": "property/6767906449166333/019fd927-691a-770f-ac47-357106939128.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8483624096618693661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-riverfront-promenade",
      "poi_latitude": "40.0816126",
      "poi_longitude": "-74.8608174",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 609-386-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJueBSfodOwYkRHcTm7irju3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8028f09-7025-44cd-8a9d-2a4607506945",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Rancocas Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "794 Rancocas Mt Holly Rd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "Nature center providing classes, camps, and diverse trails for exploring a creek-laced forest.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-696a-742d-85fc-967be65b8a89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-696a-742d-85fc-967be65b8a89",
        "storage_key": "property/6767906449166333/019fd927-696a-742d-85fc-967be65b8a89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rancocasnaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12041066723096231629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancocas-nature-center",
      "poi_latitude": "40.00337589999999",
      "poi_longitude": "-74.8208808",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 609-261-2495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSiJzPpIwYkRzX7tamN2Gqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7670dd6c-557f-43f4-afbd-be8500511101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Virtua Willingboro Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "218A Sunset Rd, Willingboro, NJ 08046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-64ec-77e7-a6d3-2ca485017e43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-64ec-77e7-a6d3-2ca485017e43",
        "storage_key": "property/6767906449166333/019fd927-64ec-77e7-a6d3-2ca485017e43.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.virtua.org/locations/hospital-virtua-lourdes-willingboro?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7801680411581921203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-willingboro-hospital",
      "poi_latitude": "40.047081",
      "poi_longitude": "-74.881",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 609-835-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bd8-706d-a62d-633af9371144",
        "storage_key": "property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-BcnAZMwYkRs7d2z_8iRWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c8e7a1e-ccc9-4f1d-a051-c39ec68a7d4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "AFC Willingboro Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4318 US-130, Willingboro, NJ 08046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-6df7-7539-bbac-c63c4f97f253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-6df7-7539-bbac-c63c4f97f253",
        "storage_key": "property/6767906449166333/019fd927-6df7-7539-bbac-c63c4f97f253.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.afcurgentcare.com/willingboro/?utm_source=gmb&utm_medium=organic&utm_campaign=afc_willingboro_gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4577169175174274850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-willingboro-urgent-care",
      "poi_latitude": "40.0478184",
      "poi_longitude": "-74.90026879999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-871-2045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfDX_nRMwYkRIl8hKx1fhT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_241c3b30-9e4a-4e77-9188-dc26945aee8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 Woodlane Rd, Eastampton Township, NJ 08060, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-8869-70e8-a000-410e987bf3bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-8869-70e8-a000-410e987bf3bb",
        "storage_key": "property/6767906449166333/019fd927-8869-70e8-a000-410e987bf3bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/eastampton-nj-pharmacies/1300-woodlane-road-eastampton-nj-08060/storeid=2231?WT.mc_id=LS_GOOGLE_FS_2231",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106995568982211812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.0047989",
      "poi_longitude": "-74.7646575",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 609-702-3931",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDYsMZOpIwYkR5LxdT9VBaO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52eff36f-a0cc-41b5-a246-d5e832370eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4296 US-130, Willingboro, NJ 08046, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0cd3-770d-bd32-c61a79bb4c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-0cd3-770d-bd32-c61a79bb4c32",
        "storage_key": "property/6767906449166333/019fd927-0cd3-770d-bd32-c61a79bb4c32.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4296+route+130-willingboro-nj-08046/id=5987",
      "poi_directions_map_url": "https://maps.google.com/?cid=12717403342269227439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.045957",
      "poi_longitude": "-74.90335019999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-871-9017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkw8AH3ZMwYkRr6FSyfVKfbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83d2a17a-a17e-494f-b013-00f84f280b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "URGE FITNESS Edgewater Park",
      "poi_type": "Health and Wellness",
      "poi_address": "4355 US-130, Edgewater Park, NJ 08010, USA",
      "poi_short_description": "Gym with boxing, yoga, and other group classes plus child care, and a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-80e3-72ec-9d43-7a6a9ebe7a51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-80e3-72ec-9d43-7a6a9ebe7a51",
        "storage_key": "property/6767906449166333/019fd927-80e3-72ec-9d43-7a6a9ebe7a51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urgefitness.com/edgewater-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805854477830810439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urge-fitness-edgewater-park",
      "poi_latitude": "40.0538558",
      "poi_longitude": "-74.89687339999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 609-216-7456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-_BakdNwYkRR2tznMyIt7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e45cc636-7d7e-4fa6-ada9-db4ca597ad50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "320 Young Ave, Moorestown, NJ 08057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-7780-71fd-aa5f-885673917d12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-7780-71fd-aa5f-885673917d12",
        "storage_key": "property/6767906449166333/019fd927-7780-71fd-aa5f-885673917d12.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.clubpilates.com/moorestown/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17036439842680492587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.9710541",
      "poi_longitude": "-74.917508",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 856-444-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3XtbP9LwYkRK1JIJMaXbew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7bb74ac7-8e16-4019-9829-40a8572536fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "The Studio for Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "101 E Main St Suite 103, Mt Laurel Township, NJ 08054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-7677-721a-aca1-0a87d56f5e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-7677-721a-aca1-0a87d56f5e5b",
        "storage_key": "property/6767906449166333/019fd927-7677-721a-aca1-0a87d56f5e5b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://thestudioforyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14413703466578673709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-studio-for-yoga",
      "poi_latitude": "39.96554709999999",
      "poi_longitude": "-74.9421929",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-430-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJYbQz2A1wYkRLQA9j-_CB8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3dae827c-5967-42fd-a40e-5b4ed1d4d8b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Beverly Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "3 Warren St, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7194495649031493203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beverly-chiropractic",
      "poi_latitude": "40.0655693",
      "poi_longitude": "-74.91211679999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-387-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yUCnmdMwYkRU5aduqz712M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cadf591a-b9cf-407b-92dc-3800d178617e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Willingboro Lakes County Park",
      "poi_type": "Recreation",
      "poi_address": "60 Beverly - Rancocas Rd, Willingboro, NJ 08046, USA",
      "poi_short_description": "Well-maintained park featuring playgrounds and paved trails plus wooded trails for dog-friendly strolls.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-8dc9-732b-a04b-42d3a99bbf8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-8dc9-732b-a04b-42d3a99bbf8d",
        "storage_key": "property/6767906449166333/019fd927-8dc9-732b-a04b-42d3a99bbf8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://co.burlington.nj.us/949/Willingboro-Lakes-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1380136217803242761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willingboro-lakes-county-park",
      "poi_latitude": "40.0357192",
      "poi_longitude": "-74.91474889999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 609-265-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeas3CghLwYkRCT3Q65M6JxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab9170e9-d630-4215-abac-e6e6bd3cd312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Mill Creek Park",
      "poi_type": "Recreation",
      "poi_address": "300 Beverly - Rancocas Rd, Willingboro, NJ 08046, USA",
      "poi_short_description": "This 14-acre park offers nature trails, playgrounds, a pavilion & picnic tables.",
      "poi_long_description": "This 14-acre park offers nature trails, playgrounds, a pavilion & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-9296-751e-bf93-286019cd266d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-9296-751e-bf93-286019cd266d",
        "storage_key": "property/6767906449166333/019fd927-9296-751e-bf93-286019cd266d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.millcreekmetroparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14479872244619669652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-park",
      "poi_latitude": "40.0224162",
      "poi_longitude": "-74.9082865",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 609-877-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6aDdaNLwYkRlPCXvRbX8sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ed2b0dc-c70b-43e9-82ee-c39a49f600e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Pennington Park",
      "poi_type": "Recreation",
      "poi_address": "801 Creek Rd, Delanco, NJ 08075, USA",
      "poi_short_description": "Park with nature trails, playgrounds, picnic facilities, a community garden & off-leash dog areas.",
      "poi_long_description": "Park with nature trails, playgrounds, picnic facilities, a community garden & off-leash dog areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-979b-7208-a93d-1a46f7325a6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-979b-7208-a93d-1a46f7325a6b",
        "storage_key": "property/6767906449166333/019fd927-979b-7208-a93d-1a46f7325a6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.co.burlington.nj.us/943/Pennington-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17674041427092000312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennington-park",
      "poi_latitude": "40.036653",
      "poi_longitude": "-74.9323939",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 609-265-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aVEHnBLwYkROE5bbwnPRvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d47c9a55-9281-436b-bce3-733fd23a78a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Amico Island Park",
      "poi_type": "Recreation",
      "poi_address": "81 Norman Ave, Riverside, NJ 08075, USA",
      "poi_short_description": "A 55-acre peninsula of forest, meadow & wetlands offering hiking, biking, fishing & picnicking.",
      "poi_long_description": "A 55-acre peninsula of forest, meadow & wetlands offering hiking, biking, fishing & picnicking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-9fd8-72db-a623-1f3bb9c895a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-9fd8-72db-a623-1f3bb9c895a8",
        "storage_key": "property/6767906449166333/019fd927-9fd8-72db-a623-1f3bb9c895a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.burlington.nj.us/926/Amico-Island-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16098013433284362138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amico-island-park",
      "poi_latitude": "40.0358711",
      "poi_longitude": "-74.98169349999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 609-265-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJURme8ri0xokRmn9hOO2hZ98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94c05815-4e1a-490f-9f03-228d1991ff51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Memorial Field",
      "poi_type": "Recreation",
      "poi_address": "Edgewater Park, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18136450583949907072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-field",
      "poi_latitude": "40.0602285",
      "poi_longitude": "-74.91320449999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____Q2RMwYkRgJTCDredsfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e8d5951-f38a-4730-8940-5aca012bdf3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "City of Beverly Municipal Building",
      "poi_type": "Recreation",
      "poi_address": "446 Broad St, Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thecityofbeverly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13805972629679708928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-beverly-municipal-building",
      "poi_latitude": "40.0629904",
      "poi_longitude": "-74.9206914",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-387-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1b76-729a-b668-561d33d247dc",
        "storage_key": "property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8P3_mFMwYkRABvTovWqmL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_608aba10-9dce-4b55-98a7-4aa906562e60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Glen Foerd",
      "poi_type": "Recreation",
      "poi_address": "5001 Grant Ave, Philadelphia, PA 19114, USA",
      "poi_short_description": "Venue boasting an extravagant, 1850s-built, waterfront mansion with river views on 18 acres of green space, plus a park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-96f8-719b-acfd-36464d267342.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-96f8-719b-acfd-36464d267342",
        "storage_key": "property/6767906449166333/019fd927-96f8-719b-acfd-36464d267342.webp",
        "width": 800,
        "height": 505
      },
      "poi_business_url": "http://www.glenfoerd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11517563994346634499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glen-foerd",
      "poi_latitude": "40.0516472",
      "poi_longitude": "-74.97881939999999",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 30 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 215-632-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzcme1k2xxokRAz3cIG6b1p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8149dc1a-d4c6-497a-a861-78e769f724e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Dinoia Park",
      "poi_type": "Recreation",
      "poi_address": "Beverly, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-a901-753a-9b8c-fa223c099ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-a901-753a-9b8c-fa223c099ce2",
        "storage_key": "property/6767906449166333/019fd927-a901-753a-9b8c-fa223c099ce2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edgewaterpark-nj.com/content/163/342/828.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514294370290823388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dinoia-park",
      "poi_latitude": "40.0547304",
      "poi_longitude": "-74.9095507",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 609-877-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8-gdnBMwYkR3PDykWiR5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b04b472a-fa6d-47ed-8875-9c4fa607608c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Roosevelt Park",
      "poi_type": "Recreation",
      "poi_address": "Edgewater Park, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5785029324874596237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosevelt-park",
      "poi_latitude": "40.0622495",
      "poi_longitude": "-74.9095507",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1822-73dd-924c-53e3dff96b2a",
        "storage_key": "property/6767906449166333/019d0269-1822-73dd-924c-53e3dff96b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____G2ZMwYkRjT9eRIWNSFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e54a3ba-1e05-4d8e-b9bf-c71709d57ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Beverly - Edgewater Park",
      "poi_type": "Transportation",
      "poi_address": "Edgewater Park, NJ 08010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-b708-72c9-8b2a-7a504d3fc786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-b708-72c9-8b2a-7a504d3fc786",
        "storage_key": "property/6767906449166333/019fd927-b708-72c9-8b2a-7a504d3fc786.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14233406339317276852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beverly---edgewater-park",
      "poi_latitude": "40.061155",
      "poi_longitude": "-74.91514699999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Rx19mNMwYkRtKDMXqc3h8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc830751-a93d-4e46-adee-a71817bcecf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington County Human Services Facility",
      "poi_type": "Transportation",
      "poi_address": "795 Woodlane Rd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-a474-744e-84b5-a4dce80bd85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-a474-744e-84b5-a4dce80bd85a",
        "storage_key": "property/6767906449166333/019fd927-a474-744e-84b5-a4dce80bd85a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.co.burlington.nj.us/398/Human-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=12288672624955062710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-county-human-services-facility",
      "poi_latitude": "40.0128549",
      "poi_longitude": "-74.80530010000001",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 609-265-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9LgGcBIwYkRtnmD66Qiiqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d01bfcdc-cc24-435d-a202-9b99419b11ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transportation",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-bc69-73ad-85a2-4f6df6db196d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-bc69-73ad-85a2-4f6df6db196d",
        "storage_key": "property/6767906449166333/019fd927-bc69-73ad-85a2-4f6df6db196d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "28.4 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 40 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1e56-7021-a06f-07d2ada69593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1e56-7021-a06f-07d2ada69593",
        "storage_key": "property/6767906449166333/019d0269-1e56-7021-a06f-07d2ada69593.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dfbeb738-681b-43c3-bae8-fa9f5942cf34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Florence Light Rail Station (River Line)",
      "poi_type": "Transportation",
      "poi_address": "Florence, NJ, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9504823827517267579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florence-light-rail-station-river-line",
      "poi_latitude": "40.099875",
      "poi_longitude": "-74.80527",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBaxeYMJPwYkRe97Vk-nq54M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9e802e9f-408f-49f5-ab60-613dd83b86c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Delanco",
      "poi_type": "Transportation",
      "poi_address": "Delanco, NJ 08075, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-b1c6-73eb-99ae-1b7760fc14fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-b1c6-73eb-99ae-1b7760fc14fc",
        "storage_key": "property/6767906449166333/019fd927-b1c6-73eb-99ae-1b7760fc14fc.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6957912808281291405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delanco",
      "poi_latitude": "40.048068",
      "poi_longitude": "-74.95027999999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEyAANVlLwYkRjTq_o9V4j2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86e3a6e7-2eea-4064-8e2a-5422432752ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Cinnaminson",
      "poi_type": "Transportation",
      "poi_address": "Cinnaminson, NJ 08077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-c86f-75a4-821c-b4caa11a0d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-c86f-75a4-821c-b4caa11a0d7c",
        "storage_key": "property/6767906449166333/019fd927-c86f-75a4-821c-b4caa11a0d7c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=38302",
      "poi_directions_map_url": "https://maps.google.com/?cid=9640832317006270066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinnaminson",
      "poi_latitude": "40.016557",
      "poi_longitude": "-74.99994199999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbkrCh21xokRcs5Duukdy4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35c10734-dab8-4de8-aadb-7217e1d014ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Palmyra",
      "poi_type": "Transportation",
      "poi_address": "10 E Broad St, Palmyra, NJ 08065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-c4dd-73be-94cb-a2cec66cc5b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-c4dd-73be-94cb-a2cec66cc5b3",
        "storage_key": "property/6767906449166333/019fd927-c4dd-73be-94cb-a2cec66cc5b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12508585472305432663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmyra",
      "poi_latitude": "40.00466",
      "poi_longitude": "-75.02038999999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzmr4aO1xokRV4hgtzZsl60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2cd2508-2be0-4a4d-b4f4-7908c8c2abdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington Towne Centre",
      "poi_type": "Transportation",
      "poi_address": "Burlington, NJ 08016, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-c351-764a-82d7-7759b43d9cdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-c351-764a-82d7-7759b43d9cdb",
        "storage_key": "property/6767906449166333/019fd927-c351-764a-82d7-7759b43d9cdb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=LightRailStationLookupFrom&selLineCode=343&selStation=38297&x=53&y=17",
      "poi_directions_map_url": "https://maps.google.com/?cid=14287802248263318448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-towne-centre",
      "poi_latitude": "40.077358",
      "poi_longitude": "-74.859421",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1dgmq4lOwYkRsDvD3HF4SMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7364c72b-ea2b-421c-92ce-ccfd73762e64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington County Human Services Facility",
      "poi_type": "Major Employers",
      "poi_address": "795 Woodlane Rd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-a474-744e-84b5-a4dce80bd85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-a474-744e-84b5-a4dce80bd85a",
        "storage_key": "property/6767906449166333/019fd927-a474-744e-84b5-a4dce80bd85a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.co.burlington.nj.us/398/Human-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=12288672624955062710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-county-human-services-facility",
      "poi_latitude": "40.0128549",
      "poi_longitude": "-74.80530010000001",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 609-265-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9LgGcBIwYkRtnmD66Qiiqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3728ee17-4d2c-4282-9c13-8ff9568caa88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington County Health Department",
      "poi_type": "Major Employers",
      "poi_address": "15 Pioneer Blvd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-d458-770a-bc39-fba8c753c2a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-d458-770a-bc39-fba8c753c2a4",
        "storage_key": "property/6767906449166333/019fd927-d458-770a-bc39-fba8c753c2a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.co.burlington.nj.us/health",
      "poi_directions_map_url": "https://maps.google.com/?cid=16852486984521483358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-county-health-department",
      "poi_latitude": "40.0149214",
      "poi_longitude": "-74.8186085",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 609-265-5548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1b76-729a-b668-561d33d247dc",
        "storage_key": "property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJua7Whd1IwYkRXgRMxp8P4Ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97b11f42-a620-4135-85cb-b276a3a25c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Burlington County Administration Building",
      "poi_type": "Major Employers",
      "poi_address": "50 Rancocas Rd 3rd floor, Mt Holly, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-e753-7318-91af-582751e60db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-e753-7318-91af-582751e60db9",
        "storage_key": "property/6767906449166333/019fd927-e753-7318-91af-582751e60db9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.co.burlington.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4897314602694620972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington-county-administration-building",
      "poi_latitude": "39.9947749",
      "poi_longitude": "-74.78990879999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 609-265-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1b76-729a-b668-561d33d247dc",
        "storage_key": "property/6767906449166333/019d0269-1b76-729a-b668-561d33d247dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8lW34VIwYkRLDfyHq_B9kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96c5effa-af4c-4d50-9edd-a155f48f0500",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Virtua Mount Holly Hospital",
      "poi_type": "Major Employers",
      "poi_address": "175 Madison Ave, Mt Holly, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-ce43-736f-b786-1617a18126f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-ce43-736f-b786-1617a18126f0",
        "storage_key": "property/6767906449166333/019fd927-ce43-736f-b786-1617a18126f0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.virtua.org/locations/mount-holly-hospital?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8041120395462574078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-mount-holly-hospital",
      "poi_latitude": "39.9860013",
      "poi_longitude": "-74.79489989999999",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 609-914-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bd8-706d-a62d-633af9371144",
        "storage_key": "property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTA3gGRIwYkR_v-xX2XMl28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b25a2e7-6d73-4108-aa55-a5ec5131209c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Cooper University Hospital",
      "poi_type": "Major Employers",
      "poi_address": "1 Cooper Plaza, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-dccd-73ee-9e3a-698a1c574134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-dccd-73ee-9e3a-698a1c574134",
        "storage_key": "property/6767906449166333/019fd927-dccd-73ee-9e3a-698a1c574134.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cooperhealth.org/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=680027330547190836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-university-hospital",
      "poi_latitude": "39.9416173",
      "poi_longitude": "-75.1171062",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 35 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 856-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bd8-706d-a62d-633af9371144",
        "storage_key": "property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-ECnOTIxokRNIzSEkHxbwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_841d8eb0-20a0-4c8e-81b3-39f91b65fcab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Thomas Jefferson University Hospital",
      "poi_type": "Major Employers",
      "poi_address": "111 S 11th St, Philadelphia, PA 19107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-d6e4-777a-ad18-1e4e8f40769d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-d6e4-777a-ad18-1e4e8f40769d",
        "storage_key": "property/6767906449166333/019fd927-d6e4-777a-ad18-1e4e8f40769d.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/thomas-jefferson-university-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8538058415648513887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-jefferson-university-hospital",
      "poi_latitude": "39.9493361",
      "poi_longitude": "-75.1580218",
      "poi_miles_from_property": "19.2 mi",
      "poi_walking_minutes": "7 hours 5 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 215-955-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-1bd8-706d-a62d-633af9371144",
        "storage_key": "property/6767906449166333/019d0269-1bd8-706d-a62d-633af9371144.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3f-lCjGxokRX59DeORGfXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3caa2077-7168-4520-a3b3-46e79bd9e05c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Rowan University",
      "poi_type": "Major Employers",
      "poi_address": "201 Mullica Hill Rd, Glassboro, NJ 08028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-ec0d-71d6-a2d3-7dc73b612878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-ec0d-71d6-a2d3-7dc73b612878",
        "storage_key": "property/6767906449166333/019fd927-ec0d-71d6-a2d3-7dc73b612878.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rowan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5986131075338450699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-university",
      "poi_latitude": "39.7099689",
      "poi_longitude": "-75.1191932",
      "poi_miles_from_property": "32.8 mi",
      "poi_walking_minutes": "12 hours 9 mins",
      "poi_biking_minutes": "2 hours 51 mins",
      "poi_driving_minutes": "48 mins",
      "poi_business_phone": "+1 856-256-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUBWdKjXxokRC7d5RH8CE1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2d4f64b-696f-4aa4-83cc-930ca7d8e714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Camden County College",
      "poi_type": "Major Employers",
      "poi_address": "200 College Dr, Blackwood, NJ 08012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-e248-77cc-954c-802a06751f49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-e248-77cc-954c-802a06751f49",
        "storage_key": "property/6767906449166333/019fd927-e248-77cc-954c-802a06751f49.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.camdencc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17527533757141958008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-county-college",
      "poi_latitude": "39.78447600000001",
      "poi_longitude": "-75.03720349999999",
      "poi_miles_from_property": "26.0 mi",
      "poi_walking_minutes": "9 hours 37 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 856-227-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-139f-721d-a5e4-49f8827b72f5",
        "storage_key": "property/6767906449166333/019d0269-139f-721d-a5e4-49f8827b72f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUVFtsDXSxokReD0dVxZPPvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f66949d0-af81-4f23-b30e-3970b0c57dfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Lockheed Martin",
      "poi_type": "Major Employers",
      "poi_address": "199 Borton Landing Rd, Moorestown, NJ 08057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-f53b-75a4-a4ec-3838e9e79d27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-f53b-75a4-a4ec-3838e9e79d27",
        "storage_key": "property/6767906449166333/019fd927-f53b-75a4-a4ec-3838e9e79d27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lockheedmartin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2415388892662595380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin",
      "poi_latitude": "39.9764024",
      "poi_longitude": "-74.9173374",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 856-722-3336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfFaJX1KwYkRNP-TjWYvhSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42411ddf-5177-4218-b8bb-28fcde690a58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "poi_name": "Hampton Behavioral Health Center",
      "poi_type": "Major Employers",
      "poi_address": "650 Rancocas Rd, Westampton Township, NJ 08060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-ec2b-73a8-8d32-b7f57332865c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd927-ec2b-73a8-8d32-b7f57332865c",
        "storage_key": "property/6767906449166333/019fd927-ec2b-73a8-8d32-b7f57332865c.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://hamptonhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7013916388854105175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-behavioral-health-center",
      "poi_latitude": "40.0080083",
      "poi_longitude": "-74.8465082",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-603-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-0d08-75ba-be46-f0db692f29a4",
        "storage_key": "property/6767906449166333/019d0269-0d08-75ba-be46-f0db692f29a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaz-7chJJwYkRV4TwWctvVmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_18e3af8e-e4f2-4632-9367-dd41978dc4af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_64fba369-2c47-4bf3-9631-2634419c3389",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bbb7d0dd-549a-41eb-981e-df58faee6a3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_40e89ace-81b2-435e-8749-b4e6e591de43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_20fad2f1-b385-49a3-87ca-cef8d463aacd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fd7bc361-0c2f-4634-8b89-d33803456967",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4c2507397cc6484e5ae767a4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "rating": "5",
      "name": "false",
      "text": "Woodlane crossing apartments is a very nice quiet and safe place. I been living here for 3-4 years here and they always take care of all that needs to be done in a timely manner. They have a beautiful pool with new pool furniture and a lifeguard always on watch. They have washer and dryer place and alot of parking. All is convenient here and this is my first place i got on my own. And i can still say i enjoy being here, i got my bestfriend and another friend at the same apartments and would still recommend this apartment to anyone else.",
      "date": "false",
      "title": "All about Woodlane"
    },
    {
      "id": "ec_740a17a724e527467e2adf87",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "rating": "5",
      "name": "false",
      "text": "My leasing agent Jackie was very helpful as well as the other staff in the office. They took their time and explained everything in great detail and were able to answer every question that I had with no hesitation. Would definitely recommend to anyone looking for a new apartment",
      "date": "false",
      "title": "Leasing Agent"
    },
    {
      "id": "ec_58351cb542e67ea5c5110bc1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "rating": "5",
      "name": "false",
      "text": "I love my neigbors, my office staff and how quiet it is every night. Woodlane crossing apartments is amazing place to be. I been here 4 years and still love it.",
      "date": "false",
      "title": "i love it here"
    },
    {
      "id": "ec_a39faa3ff2ceb031ca4ea7fd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "rating": "5",
      "name": "false",
      "text": "Christina makes going to and/or calling the rent office a pleasurable experience. She does an excellent job of meeting and greeting the Residents. Christina is kind, patient and professional. Thanks Christina, for being a great staff member...keep up the great work!",
      "date": "false",
      "title": "Christina is the best!"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b5cea08e-6a8f-4ceb-8b44-a90d0a45c285",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab04-fc04-756a-8472-44081668f008.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and marble countertops, flowing into a living area with a sofa and TV.",
        "public_id": "01a0ab04-fc04-756a-8472-44081668f008",
        "storage_key": "property/6767906449166333/01a0ab04-fc04-756a-8472-44081668f008.webp",
        "width": 3072,
        "height": 2048
      },
      "virtual_tour_title": "Orchard Park Apartments",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6a6b9a179c1a19757e32619d"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_0e90f38c03d882fe8a0ab131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429456",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4c8ebf82ff797785b7c19d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429457",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4a617002703cfa76dfa21340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429458",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_6d8e15a25f3aa58c30746a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429459",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_446a5ea75a2f8fcc901b5ed6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429460",
      "name": "Pet Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6f8a511e264662b8fa6a2eaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429461",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b27b75adba864f435a572fc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429464",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3d9ce30a976ea00220ee4a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429465",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a8127a73d360dd9bdf61c8ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "429466",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4a1b68b5b5fd895676d62bed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "541013",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5601c0211027297e8c3f539a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "541014",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_07ed6690b1a9e2db83b016d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "543096",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_15e4352e21c602540cc730ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "543097",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cbcb0da3aef7c317456237ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "543113",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2ca7bd8137f2bdfcd0523024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832512",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9eff104cf4eea00ad7e2d69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832513",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_820f64a6adb8f5fac53d0f81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832517",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c0a8897be7a927f2820e4ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832519",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8b3ab07315f50f3a37659acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832520",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_56db4e5238b7f60e0b8781b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "engrain",
      "external_id": "832528",
      "name": "Yearly Pool Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 100,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Annually",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2876-4c90-71ec-ab02-01e97551cec9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-orchard-park-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333"
    },
    {
      "lead_collector_id": "019c3043-7f2a-764c-93c8-e9749550aa8c",
      "lead_source": "FACEBOOK_ADS",
      "name": "orchard-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333"
    },
    {
      "lead_collector_id": "019c3043-7f99-737a-b158-e2a656c20624",
      "lead_source": "LANDING_PAGE",
      "name": "orchard-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-beverly-nj-143",
      "search_query": "pet friendly apartments beverly nj",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Beverly, NJ",
      "h2_subtitle": "Discover pet-welcoming homes in Beverly, NJ. Enjoy a lifestyle with furry friends at Orchard Park, where pets are always welcome.",
      "page_copy": "Welcome to Orchard Park, the ideal pet-friendly apartment community in Beverly, NJ. Nestled in the heart of this charming town, our apartments offer the perfect blend of comfort and convenience. Whether you have a playful pup or a cuddly cat, our community is ready to welcome your furry family members.\n\nOur spacious one-bedroom, two-bedroom, and studio apartments are designed with modern living in mind, and our amenities cater to both residents and their pets. Not only can you enjoy a glistening swimming pool and upgraded premium interiors, but our pet-friendly atmosphere ensures that everyone's needs are met. Visit us in Burlington County and discover a place where you and your pet can truly feel at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Beverly, NJ",
      "seo_description": "Explore pet friendly apartments at Orchard Park in Beverly, NJ. Perfectly designed for modern living with your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-with-ev-charging-burlington-county-378",
      "search_query": "apartments with ev charging stations burlington county",
      "category": "Amenity",
      "h1_title": "Apartments with EV Charging in Burlington",
      "h2_subtitle": "Explore Orchard Park in Burlington County, where apartments come equipped with convenient EV charging stations.",
      "page_copy": "For eco-conscious living in Burlington County, Orchard Park offers apartments with EV charging stations. Located in the heart of Beverly, NJ, our community combines sustainability with style, providing modern homes equipped with the amenities you need for a green lifestyle.\n\nOur one-bedroom, two-bedroom, and studio apartments are not only spacious but also designed to support your electric vehicle needs. With on-site EV charging stations, you can conveniently power up and enjoy the peace of mind that comes with eco-friendly living. Beyond our advanced facilities, enjoy a range of amenities including a swimming pool and pet-friendly environment. Embrace a life that's in tune with the future at Orchard Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Charging in Burlington",
      "seo_description": "Find eco-friendly apartments with EV charging stations in Burlington County at Orchard Park. Modern, sustainable living in Beverly, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "swimming-pool-apartments-beverly-08010-648",
      "search_query": "swimming pool apartments beverly 08010",
      "category": "Amenity",
      "h1_title": "Swimming Pool Apartments in Beverly 08010",
      "h2_subtitle": "Discover apartments with a swimming pool in Beverly, NJ. Orchard Park offers ideal homes at 08010 with great amenities.",
      "page_copy": "Dive into comfort at Orchard Park, where swimming pool apartments await you in Beverly, NJ, 08010. Envision a lifestyle where you can unwind by a shimmering pool, a perfect complement to a day of modern living.\n\nOrchard Park provides not only a relaxing pool but also a range of apartment styles, including one-bedroom, two-bedroom, and studio options. Located in the friendly community of Beverly, our apartments are designed with your lifestyle in mind. Boost your day with a swim, and enjoy additional amenities like EV charging stations and resident activities, making Orchard Park a great place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Swimming Pool Apartments in Beverly 08010",
      "seo_description": "Explore Orchard Park's swimming pool apartments in Beverly, 08010. Enjoy modern living with desirable amenities including a shimmering pool.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-near-burlington-county-655",
      "search_query": "air conditioned apartments near burlington county",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments by Burlington County",
      "h2_subtitle": "Experience comfort in air conditioned apartments near Burlington County. Orchard Park in Beverly, NJ offers a cool and convenient lifestyle.",
      "page_copy": "Stay cool and comfortable at Orchard Park, where air conditioned apartments near Burlington County are designed for modern living. Located in Beverly, NJ, our community offers a serene escape with all the conveniences you desire, ensuring every day feels like a breeze.\n\nFrom one-bedroom to two-bedroom and studio apartments, each home at Orchard Park includes air conditioning, allowing you to enjoy a refreshing environment year-round. In addition to climate-controlled interiors, our community features amenities such as a swimming pool, EV charging stations, and a pet-friendly atmosphere. Make Orchard Park your haven and experience the perfect blend of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments by Burlington County",
      "seo_description": "Find air conditioned apartments near Burlington County at Orchard Park in Beverly, NJ. Enjoy a comfortable lifestyle in a modern community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-with-playground-in-beverly-nj-377",
      "search_query": "apartments with playground in beverly nj",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Beverly, NJ",
      "h2_subtitle": "Explore our Beverly, NJ community featuring apartments with a playground. Ideal for families seeking convenience and comfort.",
      "page_copy": "Welcome to Orchard Park, where family-friendly living meets modern design in Beverly, NJ. Our apartments feature a well-equipped playground, perfect for children to enjoy outdoor fun safely within the community.\n\nOrchard Park provides a selection of one-bedroom, two-bedroom, and studio apartments, offering various options for all family sizes. Nestled in the charming environment of Beverly, NJ, our community not only boasts a playground but also includes amenities like a swimming pool and resident activities. Enjoy a harmonious blend of leisure and convenience at Orchard Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Playground in Beverly, NJ",
      "seo_description": "Discover family-friendly living in Beverly, NJ. Orchard Park offers apartments with a playground and modern amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-near-burlington-county-nj-428",
      "search_query": "one bedroom apartments near burlington county nj",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Burlington County",
      "h2_subtitle": "Find ideal one-bedroom apartments near Burlington County, NJ. Orchard Park provides modern living options in a welcoming community.",
      "page_copy": "Discover the perfect one-bedroom apartments at Orchard Park, conveniently located near Burlington County in Beverly, NJ. Our community offers stylish and comfortable living spaces tailored to meet your needs.\n\nEach one-bedroom apartment at Orchard Park is designed with modern amenities and a thoughtful layout, ensuring you have the perfect backdrop for your lifestyle. Enjoy community perks such as a swimming pool, playground, and pet-friendly environment. Experience the blend of tranquility and convenience that Orchard Park delivers in Burlington County, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Burlington County",
      "seo_description": "Explore stylish one-bedroom apartments near Burlington County, NJ at Orchard Park. Enjoy a welcoming community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-in-beverly-nj-685",
      "search_query": "two bedroom apartments in beverly nj",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Beverly, NJ",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Beverly, NJ at Orchard Park. Ideal for families and roommates seeking comfort and style.",
      "page_copy": "Welcome to Orchard Park, where you can find spacious two-bedroom apartments in the heart of Beverly, NJ. Our well-designed homes provide the perfect balance of style and functionality, making them ideal for families or roommates.\n\nEach two-bedroom apartment offers upgraded features and access to community amenities such as a swimming pool, EV charging stations, and 24-hour emergency maintenance. Set in the charming setting of Beverly, NJ, Orchard Park is more than just a place to live—it's a community where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Beverly, NJ",
      "seo_description": "Find spacious two-bedroom apartments in Beverly, NJ at Orchard Park. Enjoy modern living with community amenities and upgraded features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "studio-apartments-in-08010-113",
      "search_query": "studio apartments in 08010",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in 08010",
      "h2_subtitle": "Explore modern studio apartments in 08010 at Orchard Park, Beverly, NJ. Perfect for singles and professionals seeking a vibrant community.",
      "page_copy": "Discover the contemporary studio apartments at Orchard Park, superbly located within the 08010 area of Beverly, NJ. Our studio units are designed for efficiency and style, ideal for singles and professionals looking to blend comfort with an active lifestyle.\n\nAt Orchard Park, residents can enjoy community amenities like a shimmering swimming pool, playground, and EV charging stations. Our studio apartments offer a vibrant, yet serene living experience in Beverly. With on-site management and pet-friendly policies, Orchard Park is the perfect place to call home in 08010.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in 08010",
      "seo_description": "Discover modern studio apartments in 08010 at Orchard Park, Beverly, NJ. Perfectly designed for comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-near-beverly-city-school-nj-486",
      "search_query": "apartments near Beverly City School NJ",
      "category": "School",
      "h1_title": "Apartments Near Beverly City School, NJ",
      "h2_subtitle": "Find ideal apartments near Beverly City School, NJ at Orchard Park. Ideal for families looking for convenience and quality living.",
      "page_copy": "Located conveniently near Beverly City School, NJ, Orchard Park offers a range of apartment options that are perfect for families. Choose from our one-bedroom, two-bedroom, or studio apartments designed to enhance modern living while keeping you close to educational facilities.\n\nOrchard Park provides a community atmosphere with amenities like a playground, swimming pool, and resident activities that families will enjoy. Parents will appreciate the proximity to Beverly City School, making daily routines simpler and more efficient. Discover a balanced lifestyle with convenience and quality at Orchard Park in Beverly, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Beverly City School, NJ",
      "seo_description": "Explore apartments near Beverly City School, NJ at Orchard Park. Ideal for families, offering modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "orchard-park-apartments-near-magowan-elementary-269",
      "search_query": "Orchard Park apartments close to Magowan Elementary",
      "category": "School",
      "h1_title": "Orchard Park Apartments Near Magowan Elementary",
      "h2_subtitle": "Discover convenience at Orchard Park apartments, located close to Magowan Elementary in Beverly, NJ. Ideal for families.",
      "page_copy": "At Orchard Park in Beverly, NJ, families can enjoy the advantage of proximity to Magowan Elementary School. Our community offers a selection of one-bedroom, two-bedroom, and studio apartments that perfectly blend style and functionality, making it a prime choice for families who value education and convenience.\n\nResidents of Orchard Park benefit from community-focused features such as a playground, resident activities, and a shimmering swimming pool. With on-site management and 24-hour emergency maintenance, ease of living is a cornerstone of the Orchard Park experience. Choose Orchard Park for a family-friendly environment near Magowan Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Orchard Park Apartments Near Magowan Elementary",
      "seo_description": "Live at Orchard Park near Magowan Elementary in Beverly, NJ. Ideal for families, offering convenient and quality apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "properties-near-samuel-m-ridgway-school-880",
      "search_query": "properties near Samuel M Ridgway School Burlington County",
      "category": "School",
      "h1_title": "Properties Near Samuel M Ridgway School",
      "h2_subtitle": "Explore properties near Samuel M Ridgway School in Burlington County at Orchard Park. Perfect for families looking for accessibility and amenities.",
      "page_copy": "Nestled in the heart of Burlington County, Orchard Park offers properties conveniently located near Samuel M Ridgway School. This makes Orchard Park a desirable option for families seeking quality education options and a community that supports an enriching lifestyle.\n\nResidents at Orchard Park in Beverly, NJ, enjoy amenities like a sparkling swimming pool, a playground, and EV charging stations, adding convenience to daily life. With upgraded premium apartments and pet-friendly policies, Orchard Park is not just a home, but a community tailored to fit the needs of today's families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Near Samuel M Ridgway School",
      "seo_description": "Discover Orchard Park properties near Samuel M Ridgway School, Burlington County. Ideal for families seeking convenience and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "rentals-near-charles-street-school-08010-61",
      "search_query": "rentals near Charles Street School 08010",
      "category": "School",
      "h1_title": "Rentals Near Charles Street School 08010",
      "h2_subtitle": "Find the perfect rentals near Charles Street School in 08010 at Orchard Park. Ideal for families with children.",
      "page_copy": "Situated in the charming town of Beverly, NJ, Orchard Park offers rentals located just minutes away from Charles Street School, 08010. Our community offers a range of floor plans including one-bedroom, two-bedroom, and studio apartments designed for comfort and modern living, making it a perfect choice for families with school-aged children.\n\nOrchard Park provides a vibrant lifestyle with amenities such as a swimming pool, playground, and regular resident activities. With pet-friendly policies and on-site management, our community ensures that convenience is paired with quality living. Choose Orchard Park for rentals near Charles Street School and experience the ideal blend of accessibility and family-friendly amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Charles Street School 08010",
      "seo_description": "Explore family-friendly rentals at Orchard Park near Charles Street School, 08010, offering convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-close-to-palmyra-high-school-532",
      "search_query": "apartments close to Palmyra High School Beverly NJ",
      "category": "School",
      "h1_title": "Apartments Close to Palmyra High School",
      "h2_subtitle": "Discover convenient apartments close to Palmyra High School in Beverly, NJ at Orchard Park. Perfect for families and students.",
      "page_copy": "Located in the picturesque setting of Beverly, NJ, Orchard Park offers premium living just a short distance from Palmyra High School. Our community provides an array of apartment options, including one-bedroom, two-bedroom, and studio layouts, designed for those seeking both comfort and proximity to education centers.\n\nOrchard Park stands out with amenities like a tranquil swimming pool, a playground, and a host of resident activities. With the added benefits of pet-friendly living and committed on-site management, residents enjoy both convenience and a strong community atmosphere. Choose Orchard Park for an unmatched living experience near Palmyra High School, Beverly, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Palmyra High School",
      "seo_description": "Discover apartments at Orchard Park close to Palmyra High School, Beverly, NJ. Ideal for families and students seeking a convenient and vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "living-near-rowan-college-burlington-county-512",
      "search_query": "living near Rowan College at Burlington County",
      "category": "School",
      "h1_title": "Living Near Rowan College Burlington County",
      "h2_subtitle": "Experience quality living near Rowan College at Burlington County in Orchard Park, Beverly. Ideal for students and faculty.",
      "page_copy": "Orchard Park in Beverly, NJ offers an ideal setting for those seeking living arrangements near Rowan College at Burlington County. Our community is perfect for students, faculty, and anyone desiring both proximity to the college and the serenity of a well-managed residential area.\n\nFeaturing a selection of comfortable one-bedroom, two-bedroom, and studio apartments, Orchard Park ensures that residents have access to top-notch amenities, including a swimming pool, EV charging stations, and engaging resident activities. Our pet-friendly policy and 24-hour emergency maintenance further enhance the living experience. Enjoy the convenience and lifestyle Orchard Park provides, nestled conveniently close to Rowan College at Burlington County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Rowan College Burlington County",
      "seo_description": "Explore Orchard Park's ideal living options near Rowan College at Burlington County with modern amenities and an engaging community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "homes-near-holy-cross-prep-academy-99",
      "search_query": "homes near Holy Cross Preparatory Academy",
      "category": "School",
      "h1_title": "Homes Near Holy Cross Preparatory Academy",
      "h2_subtitle": "Explore quality homes near Holy Cross Preparatory Academy at Orchard Park, Beverly, NJ. Perfect for families seeking convenience and community.",
      "page_copy": "Orchard Park in Beverly, NJ, offers an exceptional community for families aiming to live close to Holy Cross Preparatory Academy. Our homes provide a mix of one-bedroom, two-bedroom, and studio apartments, tailored for modern living and situated just a short drive away from the academy.\n\nEnjoy the appealing amenities Orchard Park has to offer, including a glistening swimming pool, an inviting playground, and a variety of resident activities. With the added benefits of pet-friendly living and dedicated on-site management, Orchard Park ensures a welcoming and dynamic environment. Opt for Orchard Park when searching for homes near Holy Cross Preparatory Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Holy Cross Preparatory Academy",
      "seo_description": "Discover family-friendly homes near Holy Cross Preparatory Academy at Orchard Park, Beverly, offering modern amenities and a lively community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-near-virtua-willingboro-hospital-219",
      "search_query": "apartments near Virtua Willingboro Hospital Burlington County",
      "category": "Hospital",
      "h1_title": "Apartments Near Virtua Willingboro Hospital",
      "h2_subtitle": "Find convenient apartments near Virtua Willingboro Hospital in Burlington County at Orchard Park, Beverly, NJ. Ideal for healthcare professionals.",
      "page_copy": "Orchard Park in Beverly, NJ provides an excellent living option for those working at or visiting Virtua Willingboro Hospital. Our community offers studio, one-bedroom, and two-bedroom apartments, perfect for healthcare professionals seeking a convenient and comfortable home base close to their workplace in Burlington County.\n\nResidents at Orchard Park benefit from a variety of amenities designed to enhance everyday living, such as a shimmering swimming pool, EV charging stations, and engaging resident activities. With our pet-friendly environment and attentive on-site management, Orchard Park offers more than just a place to live—it's a community where you can thrive. Choose Orchard Park for the perfect mix of proximity and lifestyle near Virtua Willingboro Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Virtua Willingboro Hospital",
      "seo_description": "Explore apartments at Orchard Park near Virtua Willingboro Hospital, Burlington County, offering comfort and convenience for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-near-willingboro-lakes-county-park-640",
      "search_query": "apartments near Willingboro Lakes County Park NJ",
      "category": "Park",
      "h1_title": "Apartments Near Willingboro Lakes County Park",
      "h2_subtitle": "Discover serene apartments near Willingboro Lakes County Park in NJ at Orchard Park. Perfect for nature lovers seeking a blend of comfort and convenience.",
      "page_copy": "Located in the heart of Beverly, NJ, Orchard Park offers the ideal living environment for those wanting apartments near Willingboro Lakes County Park. With options ranging from studio to two-bedroom units, our community caters to individuals and families who appreciate the tranquility of nature just moments away.\n\nAt Orchard Park, residents enjoy more than just a prime location. Our top-tier amenities include a sparkling swimming pool, convenient EV charging stations, and engaging resident activities, all contributing to a vibrant community atmosphere. With our pet-friendly policy and 24-hour emergency maintenance, you'll find exceptional support and comfort at Orchard Park. Choose Orchard Park for the perfect balance of nature and modern living, right near Willingboro Lakes County Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Willingboro Lakes County Park",
      "seo_description": "Experience living near nature at Orchard Park, offering apartments close to Willingboro Lakes County Park, NJ, with modern amenities and a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "mill-creek-park-nearby-apartments-beverly-nj-513",
      "search_query": "Mill Creek Park nearby apartments Beverly",
      "category": "Park",
      "h1_title": "Mill Creek Park Nearby Apartments Beverly",
      "h2_subtitle": "Find your perfect home at Orchard Park, with nearby apartments close to Mill Creek Park in Beverly, NJ. Embrace nature and community living.",
      "page_copy": "Nestled in the charming town of Beverly, NJ, Orchard Park offers an ideal residence for those searching for apartments near the beautiful Mill Creek Park. Our selection of studio, one-bedroom, and two-bedroom apartments caters to a variety of lifestyles, providing both comfort and proximity to outdoor adventures.\n\nOrchard Park residents enjoy premium amenities such as a shimmering swimming pool and vibrant resident activities, enhancing the sense of community. With features like pet-friendly options and on-site management, you'll find that Orchard Park not only meets practical needs but also elevates everyday living. Settle into a home where you can enjoy the natural beauty of Mill Creek Park and the conveniences of a modern apartment community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mill Creek Park Nearby Apartments Beverly",
      "seo_description": "Discover Orchard Park in Beverly, offering apartments near Mill Creek Park, NJ. Enjoy community living with modern amenities and nature close by.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "pennington-park-apartments-burlington-county-711",
      "search_query": "Pennington Park apartments Burlington County",
      "category": "Park",
      "h1_title": "Pennington Park Apartments Burlington County",
      "h2_subtitle": "Discover Orchard Park's ideal location with apartments near Pennington Park in Burlington County. Perfect for those who love nature and convenience.",
      "page_copy": "Experience the best of Burlington County living at Orchard Park, offering convenient apartments near Pennington Park. Our community in Beverly, NJ provides a range of studio, one-bedroom, and two-bedroom apartments, designed to suit both individual and family needs.\n\nAt Orchard Park, not only do you get easy access to the recreational trails and scenic views of Pennington Park, but you also enjoy a host of modern amenities. Benefit from our shimmering swimming pool, pet-friendly environment, and engaging resident activities. With dedicated on-site management and 24-hour emergency maintenance, Orchard Park ensures a comfortable and supportive living experience. Choose Orchard Park for unparalleled convenience and community, just a stone's throw from Pennington Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pennington Park Apartments Burlington County",
      "seo_description": "Live at Orchard Park in Burlington County, offering convenient access to Pennington Park and modern amenities for a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "amico-island-park-close-to-orchard-park-164",
      "search_query": "Amico Island Park close to Orchard Park",
      "category": "Park",
      "h1_title": "Amico Island Park Close to Orchard Park",
      "h2_subtitle": "Enjoy living at Orchard Park, conveniently located near Amico Island Park. Experience nature and modern amenities just minutes from home.",
      "page_copy": "Situated in Beverly, NJ, Orchard Park offers residents the unique opportunity to live near the scenic beauty of Amico Island Park. Our community provides a selection of apartment homes, including studios, one-bedroom, and two-bedroom options, tailored to fit diverse living preferences.\n\nResidents benefit from the best of both worlds—proximity to the outdoor adventures and picturesque landscapes of Amico Island Park, along with the modern conveniences of Orchard Park's amenities. Dive into relaxation with our swimming pool, stay eco-friendly with EV charging stations, and enjoy a pet-friendly atmosphere. With 24-hour emergency maintenance and a dedicated on-site management team, Orchard Park ensures a comfortable lifestyle near Amico Island Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amico Island Park Close to Orchard Park",
      "seo_description": "Orchard Park in Beverly offers modern apartments close to Amico Island Park, providing nature access and luxury amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-near-memorial-field-08010-308",
      "search_query": "apartments near Memorial Field 08010",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Field 08010",
      "h2_subtitle": "Live at Orchard Park, ideally situated near Memorial Field in the 08010 area. Enjoy convenience and modern living close to recreational spaces.",
      "page_copy": "Orchard Park in Beverly, NJ is the perfect choice for those looking for apartments near Memorial Field in the 08010 area. Our community offers an array of studio, one-bedroom, and two-bedroom apartments, all thoughtfully designed for modern living.\n\nAt Orchard Park, residents can enjoy the proximity to Memorial Field's sports and leisure facilities, alongside a wealth of on-site amenities. Dive into our shimmering swimming pool, participate in community events, and benefit from 24-hour emergency maintenance. With our pet-friendly options and eco-friendly features like EV charging stations, Orchard Park caters to a balanced and sustainable lifestyle, making it ideal for families and individuals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Field 08010",
      "seo_description": "Discover Orchard Park in Beverly, NJ, offering stylish apartments near Memorial Field in 08010, perfect for active lifestyles and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "dinoia-park-surrounding-area-apartments-957",
      "search_query": "Dinoia Park surrounding area apartments",
      "category": "Park",
      "h1_title": "Dinoia Park Surrounding Area Apartments",
      "h2_subtitle": "Explore Orchard Park, located in the vibrant area surrounding Dinoia Park. Enjoy a blend of natural beauty and modern amenities in Burlington County.",
      "page_copy": "Nestled in the charming town of Beverly, NJ, Orchard Park offers the perfect home base for those seeking apartments in the Dinoia Park surrounding area. Our spacious studio, one-bedroom, and two-bedroom units are designed with contemporary lifestyles in mind, providing a comfortable and stylish living environment.\n\nResidents of Orchard Park enjoy easy access to the recreational opportunities at Dinoia Park, while benefiting from a host of luxurious on-site features such as a swimming pool, playground, and resident activities. Our pet-friendly community, complete with EV charging stations and dedicated management, ensures a blend of convenience and community spirit, making Orchard Park an ideal choice for those looking to be close to the natural charm of Dinoia Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dinoia Park Surrounding Area Apartments",
      "seo_description": "Orchard Park offers stylish living options near Dinoia Park. Enjoy natural beauty, modern amenities, and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "roosevelt-park-connected-apartments-beverly-nj-48",
      "search_query": "Roosevelt Park connected apartments Beverly NJ",
      "category": "Park",
      "h1_title": "Roosevelt Park Connected Apartments Beverly NJ",
      "h2_subtitle": "Discover Orchard Park's connectivity to Roosevelt Park in Beverly, NJ. Experience the perfect blend of outdoor activities and modern living.",
      "page_copy": "Orchard Park in Beverly, NJ, offers the quintessential location for those seeking Roosevelt Park-connected apartments. Our community presents a variety of living spaces, including studio, one-bedroom, and two-bedroom apartments, each crafted to meet your modern lifestyle needs.\n\nWith Roosevelt Park nearby, Orchard Park's residents enjoy the luxury of vibrant greenery and outdoor activities, complemented by features like a shimmering swimming pool and pet-friendly facilities. Enjoy the convenience of on-site management, EV charging stations, and resident activities, ensuring a seamless blend of relaxation and recreation. Orchard Park provides a harmonious living experience where the charm of Beverly NJ meets contemporary comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roosevelt Park Connected Apartments Beverly NJ",
      "seo_description": "Explore Orchard Park in Beverly, NJ, offering beautifully connected living to Roosevelt Park, with modern amenities and outdoor leisure options.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "apartments-near-philadelphia-airport-nj-556",
      "search_query": "apartments near Philadelphia International Airport NJ",
      "category": "Transit",
      "h1_title": "Apartments Near Philadelphia International Airport NJ",
      "h2_subtitle": "Orchard Park offers easy access to Philadelphia International Airport from NJ. Enjoy convenience and luxury with our modern living spaces in Beverly.",
      "page_copy": "Conveniently located in Beverly, NJ, Orchard Park is ideal for those seeking apartments near Philadelphia International Airport. Our range of studio, one-bedroom, and two-bedroom apartments provides a versatile lineup of living options designed for the modern resident.\n\nJust a short drive from the airport, Orchard Park ensures easy travel connections without sacrificing comfort or amenities. Residents enjoy a vibrant lifestyle with features like a sparkling swimming pool, engaging resident activities, and eco-friendly perks such as EV charging stations. Located in a serene community, Orchard Park offers the perfect blend of peaceful living with swift access to bustling Philadelphia.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Philadelphia International Airport NJ",
      "seo_description": "Find ideal living at Orchard Park, close to Philadelphia International Airport NJ. Enjoy modern amenities and convenient travel connections.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "delanco-public-transit-nearby-apartments-792",
      "search_query": "Delanco public transit nearby apartments",
      "category": "Transit",
      "h1_title": "Delanco Public Transit Nearby Apartments",
      "h2_subtitle": "Orchard Park features easy access to Delanco public transit. Discover modern living combined with convenient commuting from our Beverly, NJ location.",
      "page_copy": "Orchard Park in Beverly, NJ, offers the perfect solution for those searching for apartments with convenient access to Delanco public transit. Our community provides a selection of studio, one-bedroom, and two-bedroom apartments designed for individuals looking for comfort without compromising on connectivity.\n\nResidents delight in seamless commuting options while residing in a neighborhood rich with amenities. With Delanco public transit just moments away, Orchard Park ensures that daily commutes remain stress-free. Enjoy additional on-site perks including a swimming pool, pet-friendly environment, and community activities, making Orchard Park a well-rounded choice for modern renters.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Delanco Public Transit Nearby Apartments",
      "seo_description": "Live at Orchard Park for easy access to Delanco public transit and enjoy modern, connected living in Beverly, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "convenient-cinnaminson-transportation-apartments-32",
      "search_query": "convenient Cinnaminson transportation apartments",
      "category": "Transit",
      "h1_title": "Convenient Cinnaminson Transportation Apartments",
      "h2_subtitle": "Experience seamless commuting with our apartments near Cinnaminson transportation options. Orchard Park promises modern comfort in Beverly, NJ.",
      "page_copy": "For those seeking convenient Cinnaminson transportation options, Orchard Park in Beverly, NJ, delivers an ideal living experience. Our assorted range of one-bedroom, two-bedroom, and studio apartments cater to diverse needs, embracing modern design and amenities.\n\nPerfectly located to offer easy access to Cinnaminson's transportation links, our residents enjoy stress-free commuting. Orchard Park elevates your living experience with on-site features like a swimming pool, playground, and pet-friendly policies. Appreciate the blend of practicality and leisure in a community designed to support contemporary lifestyles and easy travel.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Cinnaminson Transportation Apartments",
      "seo_description": "Find modern living at Orchard Park, providing convenient access to Cinnaminson transportation from Beverly, NJ, with ample amenities and easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "easy-access-palmyra-transit-apartments-318",
      "search_query": "easy access to Palmyra transit apartments",
      "category": "Transit",
      "h1_title": "Easy Access to Palmyra Transit Apartments",
      "h2_subtitle": "Orchard Park offers apartments with easy access to Palmyra transit. Enjoy seamless commuting and modern amenities in Beverly, NJ.",
      "page_copy": "Situated in the heart of Beverly, NJ, Orchard Park is perfect for renters looking for easy access to Palmyra transit options. Our stylish studio, one-bedroom, and two-bedroom apartments cater to various lifestyle needs, ensuring comfort and convenience.\n\nWith quick access to Palmyra transit, Orchard Park simplifies your daily commute while offering a rich array of amenities. Residents enjoy a sparkling swimming pool, resident activities, and pet-friendly living, creating a community where convenience meets luxury. Choose Orchard Park for a well-rounded, accessible lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Easy Access to Palmyra Transit Apartments",
      "seo_description": "Discover Orchard Park for easy access to Palmyra transit. Experience convenient commuting and modern amenities in Beverly, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166333",
      "source": "custom",
      "page_item_url": "burlington-towne-centre-transit-friendly-apartments-888",
      "search_query": "Burlington Towne Centre transit-friendly apartments",
      "category": "Transit",
      "h1_title": "Burlington Towne Centre Transit-Friendly Apartments",
      "h2_subtitle": "Orchard Park provides transit-friendly living near Burlington Towne Centre. Enjoy convenience and modern amenities in Beverly, NJ.",
      "page_copy": "Located in Beverly, NJ, Orchard Park offers transit-friendly living just a stone's throw from Burlington Towne Centre. Our community presents a selection of studio, one-bedroom, and two-bedroom apartments designed with modern living in mind.\n\nResidents appreciate the proximity to Burlington Towne Centre transit options, ensuring hassle-free travel to work or leisure destinations. Alongside easy transportation access, Orchard Park boasts a suite of amenities such as a refreshing swimming pool, on-site management, and pet-friendly grounds, making it perfect for those who value convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and green spaces.",
        "public_id": "01a015da-ccd2-764a-bca0-9a658dd0e4a9",
        "storage_key": "property/6767906449166333/01a015da-ccd2-764a-bca0-9a658dd0e4a9.webp",
        "width": 2048,
        "height": 1536
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Burlington Towne Centre Transit-Friendly Apartments",
      "seo_description": "Choose Orchard Park for transit-friendly apartments near Burlington Towne Centre, blending convenience with modern living in Beverly, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5070"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976269378"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973410"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T45885T8"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveorchardpark.fatwin.com/api/websites/resources/1?x=OVJ2dkhyWEUzOWdUaEx2M3VDVkxOdXNkNERwNVdXQkthS3VZcGpyRHBrdW10RXdXK1lrNGYvanhPOExqYWVBTFVPSHhRWHR0VEc4UWRnRFU2THliOFE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "6732006579"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwjqneyv1e"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9548d716-43e6-11ef-85f6-0fea00cd244b"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548d716-43e6-11ef-85f6-0fea00cd244b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548d716-43e6-11ef-85f6-0fea00cd244b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNla09mNFpHNkJLZlFDNmVtSzJmL2c9PSIsInZhbHVlIjoiemw0WjU5TkJsdGxnU1kyU3UwKzlCUT09IiwibWFjIjoiNDFjN2MyN2RkZGM2OWM5ZjY3ODRmM2I1Yzc0MjNiNjEzYmVjOWUzN2Q1ZWY4YzUzZjE0ZTUwZGJhMWMxZTk2ZiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5070",
  "custom_repli_id": "9976269378",
  "custom_realpage_id": "4973410",
  "custom_google_gtm_id": "GTM-T45885T8",
  "custom_perq_script_url": "https://liveorchardpark.fatwin.com/api/websites/resources/1?x=OVJ2dkhyWEUzOWdUaEx2M3VDVkxOdXNkNERwNVdXQkthS3VZcGpyRHBrdW10RXdXK1lrNGYvanhPOExqYWVBTFVPSHhRWHR0VEc4UWRnRFU2THliOFE9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "6732006579",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rxwjqneyv1e",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9548d716-43e6-11ef-85f6-0fea00cd244b",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548d716-43e6-11ef-85f6-0fea00cd244b/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548d716-43e6-11ef-85f6-0fea00cd244b/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNla09mNFpHNkJLZlFDNmVtSzJmL2c9PSIsInZhbHVlIjoiemw0WjU5TkJsdGxnU1kyU3UwKzlCUT09IiwibWFjIjoiNDFjN2MyN2RkZGM2OWM5ZjY3ODRmM2I1Yzc0MjNiNjEzYmVjOWUzN2Q1ZWY4YzUzZjE0ZTUwZGJhMWMxZTk2ZiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "22c493ac-f0dc-48a9-b631-08e1bc6b280a",
  "custom_audioeye_site_hash": "68c38ee45ee190ab41730fa506e131a2"
};

export const generatedAt = '2026-10-22T20:06:22.828Z';
